export const VALID_GUESSES_FIVE = [
  'using',
  'strip',
  'these',
  'above',
  'makes',
  'about',
  'array',
  'other',
  'would',
  'given',
  'lists',
  'found',
  'order',
  'aahed',
  'aalii',
  'aargh',
  "aba's",
  'abaca',
  'abaci',
  'aback',
  'abacs',
  'abaft',
  'abaka',
  'abamp',
  'aband',
  'abase',
  'abash',
  'abask',
  'abate',
  'abaya',
  'abbas',
  'abbes',
  'abbey',
  'abbot',
  'abeam',
  'abear',
  'abele',
  'abets',
  'abhor',
  'abide',
  'abies',
  'abled',
  'abler',
  'ables',
  'ablet',
  'ablow',
  'abmho',
  'abode',
  'abohm',
  'aboil',
  'aboma',
  'aboon',
  'abord',
  'abore',
  'abort',
  'abram',
  'abray',
  'abrim',
  'abrin',
  'abris',
  "abs's",
  'absey',
  'absit',
  'abuna',
  'abune',
  'abuse',
  'abuts',
  'abuzz',
  'abyes',
  'abysm',
  'abyss',
  'acari',
  'accel',
  'accoy',
  'accra',
  "ace's",
  'acerb',
  'acers',
  'aceta',
  'ached',
  'aches',
  'achoo',
  'acids',
  'acidy',
  'acing',
  'acini',
  'ackee',
  'acmes',
  'acmic',
  'acned',
  'acnes',
  'acock',
  'acold',
  'acorn',
  'acred',
  'acres',
  'acrid',
  'acron',
  "act's",
  'acted',
  'actin',
  'acton',
  'actor',
  'acute',
  'acyls',
  'adage',
  'adapt',
  'adays',
  'addax',
  'added',
  'adder',
  'addio',
  'addle',
  'adeem',
  'adept',
  'adieu',
  'adios',
  'adits',
  'adman',
  'admen',
  'admin',
  'admit',
  'admix',
  "ado's",
  'adobe',
  'adobo',
  'adopt',
  'adore',
  'adorn',
  'adown',
  'adoze',
  'adrad',
  'adred',
  'adsum',
  'adult',
  'adunc',
  'adust',
  'advew',
  'adyta',
  "adz's",
  'adzed',
  'adzes',
  'aecia',
  'aedes',
  'aeger',
  'aegis',
  'aeons',
  'aerie',
  'aeron',
  'aeros',
  'aesir',
  'afara',
  'afars',
  'afear',
  'affix',
  'afire',
  'aflaj',
  'afoot',
  'afore',
  'afoul',
  'afrit',
  'afros',
  'after',
  'again',
  'agama',
  'agami',
  'agamy',
  'agape',
  'agars',
  'agast',
  'agate',
  'agave',
  'agaze',
  "age's",
  'agene',
  'agent',
  'agers',
  'agger',
  'aggie',
  'aggri',
  'aggro',
  'aggry',
  'aghas',
  'agila',
  'agile',
  'aging',
  'agios',
  'agism',
  'agist',
  'agita',
  'aglee',
  'aglet',
  'agley',
  'agloo',
  'aglow',
  'aglus',
  'agmas',
  'agoge',
  'agone',
  'agons',
  'agony',
  'agood',
  'agora',
  'agree',
  'agria',
  'agric',
  'agrin',
  'agron',
  'agued',
  'agues',
  'aguti',
  'ahead',
  'aheap',
  'ahems',
  'ahhed',
  'ahigh',
  'ahind',
  'ahing',
  'ahint',
  'ahold',
  'ahoys',
  'ahull',
  "aid's",
  'aided',
  'aider',
  'aides',
  'aidos',
  "ail's",
  'ailed',
  "aim's",
  'aimed',
  'aimer',
  "ain't",
  'ainas',
  'ainee',
  'aioli',
  "air's",
  'aired',
  'airer',
  'airns',
  'airth',
  'airts',
  'aisle',
  'aitch',
  'aitus',
  'aiver',
  'aizle',
  'ajiva',
  'ajuga',
  'ajwan',
  'akees',
  'akela',
  'akene',
  'aking',
  'akkas',
  "ala's",
  'alaap',
  'alack',
  'alamo',
  'aland',
  'alane',
  'alang',
  'alans',
  'alant',
  'alapa',
  'alarm',
  'alary',
  'alate',
  'alays',
  "alb's",
  'albas',
  'albee',
  'album',
  'alcid',
  'aldea',
  'alder',
  'aldol',
  "ale's",
  'alecs',
  'alefs',
  'aleft',
  'aleph',
  'alert',
  'alfas',
  'algae',
  'algal',
  'algas',
  'algid',
  'algin',
  'algor',
  'algum',
  'alias',
  'alibi',
  'alien',
  'alifs',
  'align',
  'alike',
  'aline',
  'alist',
  'alive',
  'aliya',
  'alkie',
  'alkyd',
  'alkyl',
  "all's",
  'allay',
  'allee',
  'allel',
  'alley',
  'allis',
  'allod',
  'allot',
  'allow',
  'alloy',
  'allyl',
  'almah',
  'almas',
  'almeh',
  'almes',
  'almud',
  'almug',
  'alods',
  'aloed',
  'aloes',
  'aloft',
  'aloha',
  'aloin',
  'alone',
  'along',
  'aloof',
  'aloud',
  'alowe',
  "alp's",
  'alpha',
  'altar',
  'alter',
  'altho',
  'altos',
  'alula',
  'alums',
  'alure',
  'alway',
  'amahs',
  'amain',
  'amass',
  'amate',
  'amaze',
  'amban',
  'amber',
  'ambit',
  'amble',
  'ambos',
  'ambry',
  'ameba',
  'ameer',
  'amend',
  'amene',
  'amens',
  'ament',
  'amias',
  'amice',
  'amici',
  'amide',
  'amido',
  'amids',
  'amies',
  'amiga',
  'amigo',
  'amine',
  'amino',
  'amins',
  'amirs',
  'amiss',
  'amity',
  'amlas',
  'amman',
  'ammon',
  'ammos',
  'amnia',
  'amnic',
  'amnio',
  'amoks',
  'amole',
  'among',
  'amort',
  'amour',
  'amove',
  "amp's",
  'amped',
  'ample',
  'amply',
  'ampul',
  'amrit',
  'amuck',
  'amuse',
  'amyls',
  "ana's",
  'anana',
  'anans',
  'ancho',
  'ancle',
  'ancon',
  'anear',
  'anele',
  'anend',
  'anent',
  'angas',
  'angel',
  'anger',
  'angle',
  'anglo',
  'angry',
  'angst',
  "ani's",
  'anigh',
  'anile',
  'anils',
  'anima',
  'anime',
  'animi',
  'anion',
  'anise',
  'anker',
  'ankhs',
  'ankle',
  'ankus',
  'anlas',
  'annal',
  'annas',
  'annat',
  'annex',
  'annoy',
  'annul',
  'anoas',
  'anode',
  'anole',
  'anomy',
  'anons',
  'ansae',
  "ant's",
  'antae',
  'antar',
  'antas',
  'anted',
  'antes',
  'antic',
  'antiq',
  'antis',
  'antra',
  'antre',
  'antsy',
  'anvil',
  'anyon',
  'anyus',
  'aorta',
  'apace',
  'apage',
  'apaid',
  'apart',
  'apayd',
  'apays',
  "ape's",
  'apeak',
  'apeek',
  'apers',
  'apert',
  'apery',
  'aphid',
  'aphis',
  'apian',
  'aping',
  'apiol',
  'apios',
  'apish',
  'apism',
  'apnea',
  'apode',
  'apods',
  'apoop',
  'aport',
  "app's",
  'appal',
  'appay',
  'appel',
  'apple',
  'apply',
  'appro',
  'appui',
  'appuy',
  'apres',
  'apron',
  'apses',
  'apsis',
  'apter',
  'aptly',
  'aquae',
  'aquas',
  'araba',
  'araks',
  'arame',
  'arars',
  "arb's",
  'arbas',
  'arbor',
  "arc's",
  'arced',
  'archt',
  'arcus',
  'ardeb',
  'ardor',
  'ardri',
  "are's",
  'aread',
  'areae',
  'areal',
  'arear',
  'areas',
  'areca',
  'aredd',
  'arede',
  'arefy',
  'areic',
  'arena',
  'arepa',
  'arere',
  'arete',
  'arets',
  'arett',
  'argal',
  'argan',
  'argil',
  'argle',
  'argol',
  'argon',
  'argot',
  'argue',
  'argus',
  'arhat',
  'arias',
  'ariel',
  'arils',
  'ariot',
  'arise',
  'arish',
  "ark's",
  'arled',
  'arles',
  "arm's",
  'armed',
  'armer',
  'armet',
  'armil',
  'armor',
  'arnut',
  'aroba',
  'aroid',
  'aroma',
  'arose',
  'arpen',
  'arrah',
  'arras',
  'arret',
  'arris',
  'arrow',
  'arsed',
  'arses',
  'arsis',
  'arson',
  "art's",
  'artal',
  'artel',
  'artic',
  'artsy',
  'arums',
  'arval',
  'arvos',
  'aryls',
  'asana',
  'ascot',
  'ascus',
  'asdic',
  "ash's",
  'ashed',
  'ashen',
  'ashes',
  'ashet',
  'aside',
  'askar',
  'asked',
  'asker',
  'askew',
  'askoi',
  'askos',
  "asp's",
  'aspen',
  'asper',
  'aspic',
  'aspis',
  "ass's",
  'assai',
  'assay',
  'assed',
  'asses',
  'asset',
  'assoc',
  'assot',
  'aster',
  'astir',
  'asura',
  'asway',
  'aswim',
  'asyla',
  'ataps',
  'atars',
  'ataxy',
  'atilt',
  'atimy',
  'atlas',
  "atm's",
  'atman',
  'atmas',
  'atocs',
  'atoke',
  'atoks',
  'atoll',
  'atoms',
  'atomy',
  'atone',
  'atony',
  'atopy',
  'atria',
  'atrip',
  'attap',
  'attar',
  'attic',
  'audad',
  'audio',
  'audit',
  'auger',
  'aught',
  'augur',
  "auk's",
  'aulas',
  'aulic',
  'auloi',
  'aulos',
  'aumil',
  'aunes',
  'aunts',
  'aunty',
  'aurae',
  'aural',
  'aurar',
  'auras',
  'aurei',
  'aures',
  'auric',
  'auris',
  'aurum',
  'autos',
  'auxin',
  'avail',
  'avale',
  'avant',
  'avast',
  'avens',
  'avers',
  'avert',
  'avgas',
  'avian',
  'avine',
  'avion',
  'avise',
  'aviso',
  'avize',
  "avo's",
  'avoid',
  'avoir',
  'avows',
  'await',
  'awake',
  'award',
  'aware',
  'awarn',
  'awash',
  'awave',
  'aways',
  'awdls',
  "awe's",
  'aweek',
  'aweel',
  'aweto',
  'awful',
  'awing',
  "awl's",
  "awn's",
  'awned',
  'awner',
  'awoke',
  'awols',
  'awork',
  "axe's",
  'axels',
  'axial',
  'axile',
  'axils',
  'axing',
  'axiom',
  'axion',
  'axite',
  'axled',
  'axles',
  'axman',
  'axmen',
  'axoid',
  'axone',
  'axons',
  'ayahs',
  "aye's",
  'ayelp',
  'ayins',
  'ayont',
  'ayres',
  'ayrie',
  'azans',
  'azide',
  'azido',
  'azine',
  'azlon',
  'azoic',
  'azole',
  'azons',
  'azote',
  'azoth',
  'azure',
  'azury',
  'azygy',
  'azyme',
  'azyms',
  "baa's",
  'baaed',
  'baals',
  'babas',
  'babel',
  'babes',
  'babka',
  'babul',
  'bacca',
  'bacco',
  'baccy',
  'bachs',
  'backs',
  'bacon',
  "bad's",
  'baddy',
  'badge',
  'badly',
  'baels',
  'baffs',
  'baffy',
  "bag's",
  'bagel',
  'baggy',
  'bahts',
  'bahut',
  'bails',
  'bairn',
  'baith',
  'baits',
  'baiza',
  'baize',
  'bajan',
  'bajee',
  'bajra',
  'bajri',
  'bajus',
  'baked',
  'baken',
  'baker',
  'bakes',
  'bakra',
  'balas',
  'balds',
  'baldy',
  'baled',
  'baler',
  'bales',
  'balks',
  'balky',
  'balls',
  'bally',
  'balms',
  'balmy',
  'baloo',
  'balsa',
  'balti',
  'balus',
  "ban's",
  'banal',
  'banco',
  'bancs',
  'banda',
  'bands',
  'bandy',
  'baned',
  'banes',
  'bangs',
  'bania',
  'banjo',
  'banks',
  'banns',
  'bants',
  'banty',
  "bap's",
  'bapus',
  "bar's",
  'barbe',
  'barbs',
  'barca',
  'barde',
  'bardo',
  'bards',
  'bardy',
  'bared',
  'barer',
  'bares',
  'barfs',
  'barfy',
  'barge',
  'baric',
  'barit',
  'barks',
  'barky',
  'barms',
  'barmy',
  'barns',
  'barny',
  'baron',
  'barra',
  'barre',
  'barye',
  'basal',
  'basan',
  'based',
  'baser',
  'bases',
  'basho',
  'basic',
  'basil',
  'basin',
  'basis',
  'basks',
  'bason',
  'basse',
  'bassi',
  'basso',
  'bassy',
  'basta',
  'baste',
  'basto',
  'basts',
  "bat's",
  'batch',
  'bated',
  'bates',
  'bathe',
  'baths',
  'batik',
  'baton',
  'batta',
  'batts',
  'battu',
  'batty',
  'bauds',
  'baulk',
  'baurs',
  'bavin',
  'bawds',
  'bawdy',
  'bawls',
  'bawns',
  'bawrs',
  'bawty',
  "bay's",
  'bayed',
  'bayle',
  'bayou',
  'bazar',
  'bazoo',
  "bbl's",
  'beach',
  'beads',
  'beady',
  'beaks',
  'beaky',
  'beams',
  'beamy',
  'beano',
  'beans',
  'beany',
  'beard',
  'bears',
  'beast',
  'beath',
  'beats',
  'beaus',
  'beaut',
  'beaux',
  'bebop',
  'becap',
  'becks',
  "bed's",
  'bedad',
  'bedel',
  'bedew',
  'bedim',
  'bedye',
  "bee's",
  'beech',
  'beedi',
  'beefs',
  'beefy',
  'beeps',
  'beers',
  'beery',
  'beets',
  'befit',
  'befog',
  "beg's",
  'begad',
  'began',
  'begar',
  'begat',
  'begem',
  'beget',
  'begin',
  'begot',
  'begum',
  'begun',
  'beige',
  'beigy',
  'being',
  'bejel',
  'bekah',
  "bel's",
  'belah',
  'belay',
  'belch',
  'belee',
  'belga',
  'belie',
  'belle',
  'bells',
  'belly',
  'below',
  'belts',
  'bemas',
  'bemix',
  "ben's",
  'bench',
  'bends',
  'bendy',
  'benes',
  'benet',
  'benis',
  'benne',
  'benni',
  'benny',
  'bensh',
  'bento',
  'bents',
  'benty',
  'beray',
  'beres',
  'beret',
  'bergs',
  'berks',
  'berme',
  'berms',
  'berob',
  'berry',
  'berth',
  'beryl',
  'besat',
  'besee',
  'beses',
  'beset',
  'besit',
  'besom',
  'besot',
  'bests',
  "bet's",
  'betas',
  'betel',
  'betes',
  'beths',
  'betid',
  'beton',
  'betta',
  'betty',
  'bevel',
  'bever',
  'bevor',
  'bevue',
  'bevvy',
  'bewet',
  'bewig',
  "bey's",
  'bezel',
  'bezes',
  'bezil',
  'bhaji',
  'bhang',
  'bhels',
  'bhoot',
  'bhuts',
  'biali',
  'bialy',
  "bib's",
  'bibbs',
  'bible',
  'biccy',
  'bicep',
  'bices',
  "bid's",
  'biddy',
  'bided',
  'bider',
  'bides',
  'bidet',
  'bidis',
  'bidon',
  'bield',
  'biers',
  'biffs',
  'biffy',
  'bifid',
  'bigae',
  'biggs',
  'biggy',
  'bigha',
  'bight',
  'bigly',
  'bigos',
  'bigot',
  'bijou',
  'biked',
  'biker',
  'bikes',
  'bikie',
  'bilbo',
  'bilby',
  'biles',
  'bilge',
  'bilgy',
  'bilks',
  'bills',
  'billy',
  'bimah',
  'bimas',
  'bimbo',
  "bin's",
  'binal',
  'bindi',
  'binds',
  'bines',
  'binge',
  'bingo',
  'bings',
  'bingy',
  'binit',
  'binks',
  'bints',
  "bio's",
  'biogs',
  'biome',
  'biont',
  'biota',
  'biped',
  'bipod',
  'birch',
  'birds',
  'birks',
  'birle',
  'birls',
  'biros',
  'birrs',
  'birse',
  'birsy',
  'birth',
  'bises',
  'bisks',
  'bison',
  "bit's",
  'bitch',
  'biter',
  'bites',
  'bitok',
  'bitos',
  'bitsy',
  'bitte',
  'bitts',
  'bitty',
  'bivvy',
  "biz's",
  'bizes',
  'blabs',
  'black',
  'blade',
  'blads',
  'blaes',
  'blaff',
  'blags',
  'blahs',
  'blain',
  'blame',
  'blams',
  'bland',
  'blank',
  'blare',
  'blase',
  'blash',
  'blast',
  'blate',
  'blats',
  'blatt',
  'blawn',
  'blaws',
  'blays',
  'blaze',
  'bleak',
  'blear',
  'bleat',
  'blebs',
  'bleed',
  'bleep',
  'blees',
  'blend',
  'blent',
  'bless',
  'blest',
  'blets',
  'bleys',
  'blimp',
  'blimy',
  'blind',
  'bling',
  'blini',
  'blink',
  'blins',
  'blips',
  'bliss',
  'blite',
  'blitz',
  'bloat',
  'blobs',
  'block',
  'blocs',
  'blogs',
  'bloke',
  'blond',
  'blood',
  'bloom',
  'bloop',
  'blore',
  'blots',
  'blown',
  'blows',
  'blowy',
  'blubs',
  'blude',
  'blued',
  'bluer',
  'blues',
  'bluet',
  'bluey',
  'bluff',
  'blume',
  'blunt',
  'blurb',
  'blurs',
  'blurt',
  'blush',
  'blype',
  "boa's",
  'boaks',
  'board',
  'boars',
  'boart',
  'boast',
  'boats',
  "bob's",
  'bobac',
  'bobak',
  'bobby',
  'bocca',
  'bocce',
  'bocci',
  'boche',
  'bocks',
  "bod's",
  'boded',
  'bodes',
  'bodge',
  'bodle',
  'boffo',
  'boffs',
  "bog's",
  'bogan',
  'bogey',
  'boggy',
  'bogie',
  'bogle',
  'bogon',
  'bogue',
  'bogus',
  'bohea',
  'bohos',
  'boils',
  'boing',
  'boink',
  'boite',
  'boked',
  'bokes',
  'bokos',
  'bolar',
  'bolas',
  'bolds',
  'boles',
  'bolix',
  'bolls',
  'bolos',
  'bolts',
  'bolus',
  'bomas',
  'bombe',
  'bombo',
  'bombs',
  'bonce',
  'bonds',
  'boned',
  'boner',
  'bones',
  'boney',
  'bongo',
  'bongs',
  'bonks',
  'bonne',
  'bonny',
  'bonus',
  'bonza',
  'bonze',
  "boo's",
  'boobs',
  'booby',
  'boody',
  'booed',
  'boogy',
  'boohs',
  'books',
  'booky',
  'booms',
  'boomy',
  'boong',
  'boons',
  'boors',
  'boost',
  'booth',
  'boots',
  'booty',
  'booze',
  'boozy',
  "bop's",
  'borak',
  'boral',
  'boras',
  'borax',
  'borde',
  'bored',
  'boree',
  'borel',
  'borer',
  'bores',
  'borgo',
  'boric',
  'borks',
  'borne',
  'boron',
  'borts',
  'borty',
  'bortz',
  "bos'n",
  'bosks',
  'bosky',
  'bosom',
  'boson',
  'bossy',
  'bosun',
  "bot's",
  'botas',
  'botch',
  'botel',
  'bothy',
  'botos',
  'botte',
  'botts',
  'botty',
  'bouge',
  'bough',
  'bouks',
  'boule',
  'boult',
  'bound',
  'bourd',
  'bourg',
  'bourn',
  'bouse',
  'bousy',
  'bouts',
  'bovid',
  "bow's",
  'bowed',
  'bowel',
  'bower',
  'bowet',
  'bowls',
  'bowse',
  "box's",
  'boxed',
  'boxen',
  'boxer',
  'boxes',
  "boy's",
  'boyar',
  'boyau',
  'boygs',
  'boyla',
  'boyos',
  'bozos',
  "bpm's",
  "bps's",
  "br'er",
  "bra's",
  'brace',
  'brach',
  'brack',
  'bract',
  'brads',
  'braes',
  'brags',
  'braid',
  'brail',
  'brain',
  'brake',
  'braky',
  'brame',
  'brand',
  'brank',
  'brans',
  'brant',
  'brash',
  'brass',
  'brats',
  'brava',
  'brave',
  'bravi',
  'bravo',
  'brawl',
  'brawn',
  'braws',
  'braxy',
  'brays',
  'braza',
  'braze',
  'bread',
  'break',
  'bream',
  'brede',
  'breed',
  'brees',
  'breis',
  'breme',
  'brens',
  'brent',
  'brere',
  'breve',
  'brews',
  'briar',
  'bribe',
  'brick',
  'bride',
  'brief',
  'brier',
  'bries',
  'brigs',
  'brill',
  'brims',
  'brine',
  'bring',
  'brink',
  'brins',
  'briny',
  'brios',
  'brise',
  'brisk',
  'brith',
  'brits',
  'britt',
  "bro's",
  'broad',
  'broch',
  'brock',
  'brogh',
  'brogs',
  'broil',
  'broke',
  'brome',
  'bromo',
  'bronc',
  'brood',
  'brook',
  'brool',
  'broom',
  'broos',
  'brose',
  'brosy',
  'broth',
  'brown',
  'brows',
  'brugh',
  'bruin',
  'bruit',
  'brule',
  'brume',
  'brung',
  'brunt',
  'brush',
  'brusk',
  'brust',
  'brute',
  'buats',
  'buaya',
  'buaze',
  "bub's",
  'bubal',
  'bubba',
  'bubby',
  'bubus',
  'buchu',
  'bucko',
  'bucks',
  'bucku',
  "bud's",
  'buddy',
  'budge',
  'budos',
  'bueno',
  'buffa',
  'buffe',
  'buffi',
  'buffo',
  'buffs',
  'buffy',
  "bug's",
  'buggy',
  'bugle',
  'buhls',
  'buhrs',
  'build',
  'built',
  'bulbs',
  'bulge',
  'bulgy',
  'bulks',
  'bulky',
  'bulla',
  'bulls',
  'bully',
  'bulse',
  "bum's",
  'bumbo',
  'bumfs',
  'bumph',
  'bumps',
  'bumpy',
  "bun's",
  'bunas',
  'bunce',
  'bunch',
  'bunco',
  'bunds',
  'bundt',
  'bundu',
  'bundy',
  'bungs',
  'bungy',
  'bunia',
  'bunje',
  'bunjy',
  'bunko',
  'bunks',
  'bunns',
  'bunny',
  'bunts',
  'bunty',
  'bunya',
  'buoys',
  'buppy',
  "bur's",
  'buran',
  'buras',
  'burbs',
  'burds',
  'buret',
  'burgh',
  'burgs',
  'burin',
  'burka',
  'burke',
  'burls',
  'burly',
  'burns',
  'burnt',
  'buroo',
  'burps',
  'burqa',
  'burro',
  'burrs',
  'burry',
  'bursa',
  'burse',
  'burst',
  "bus's",
  'busby',
  'bused',
  'buses',
  'bushy',
  'busks',
  'busky',
  'bussu',
  'busts',
  'busty',
  "but's",
  'butch',
  'buteo',
  'butes',
  'butle',
  'butoh',
  'butos',
  'butsu',
  'butte',
  'butts',
  'butty',
  'butut',
  'butyl',
  'buxom',
  "buy's",
  'buyer',
  'buzzy',
  'bwana',
  'bwazi',
  "bye's",
  'byked',
  'bykes',
  'bylaw',
  'byres',
  'byrls',
  'byssi',
  'bytes',
  'byway',
  "cab's",
  'cabal',
  'cabas',
  'cabby',
  'caber',
  'cabin',
  'cable',
  'cabob',
  'caboc',
  'cabre',
  'cacao',
  'cacas',
  'cache',
  'cacti',
  "cad's",
  'caddy',
  'cadee',
  'cades',
  'cadet',
  'cadge',
  'cadgy',
  'cadie',
  'cadis',
  'cadre',
  'caeca',
  'caese',
  'cafes',
  'caffs',
  'caged',
  'cager',
  'cages',
  'cagey',
  'cagot',
  'cahow',
  'caids',
  'cains',
  'caird',
  'cairn',
  'cajon',
  'cajun',
  'caked',
  'cakes',
  'cakey',
  'cakra',
  'calfs',
  'calid',
  'calif',
  'calix',
  'calks',
  'calla',
  'calls',
  'calms',
  'calmy',
  'calos',
  'calpa',
  'calve',
  'calyx',
  "cam's",
  'caman',
  'camas',
  'camel',
  'cameo',
  'cames',
  'camis',
  'camos',
  'campi',
  'campo',
  'camps',
  'campy',
  'camus',
  "can's",
  "can't",
  'canal',
  'candy',
  'caned',
  'caneh',
  'caner',
  'canes',
  'cangs',
  'canid',
  'canna',
  'canns',
  'canny',
  'canoe',
  'canon',
  'canso',
  'canst',
  'canto',
  'cants',
  'canty',
  "cap's",
  'capas',
  'caped',
  'caper',
  'capes',
  'caphs',
  'capiz',
  'caple',
  'capon',
  'capos',
  'capot',
  'capul',
  'caput',
  "car's",
  'carap',
  'carat',
  'carbo',
  'carbs',
  'carby',
  'cardi',
  'cards',
  'cardy',
  'cared',
  'carer',
  'cares',
  'caret',
  'carex',
  'cargo',
  'carks',
  'carle',
  'carls',
  'carns',
  'carny',
  'carob',
  'carol',
  'carom',
  'carpi',
  'carps',
  'carrs',
  'carry',
  'carse',
  'carta',
  'carte',
  'carts',
  'carve',
  'carvy',
  'casas',
  'casco',
  'cased',
  'cases',
  'casks',
  'casky',
  'caste',
  'casts',
  'casus',
  "cat's",
  'catch',
  'cater',
  'cates',
  'catty',
  'cauda',
  'cauld',
  'caulk',
  'cauls',
  'causa',
  'cause',
  'caved',
  'cavel',
  'caver',
  'caves',
  'cavie',
  'cavil',
  "caw's",
  'cawed',
  'caxon',
  "cay's",
  'cease',
  'cebid',
  'cecal',
  'cecum',
  'cedar',
  'ceded',
  'ceder',
  'cedes',
  'cedis',
  'cegep',
  'ceiba',
  'ceili',
  'ceils',
  'celeb',
  'cella',
  'celli',
  'cello',
  'cells',
  'celom',
  'celts',
  'cense',
  'cento',
  'cents',
  'centu',
  'ceorl',
  'cepes',
  'cerci',
  'cered',
  'ceres',
  'cerge',
  'ceria',
  'ceric',
  'ceros',
  'certs',
  'cesar',
  'cesse',
  'cesta',
  'cesti',
  'cetes',
  'cetyl',
  "cha's",
  'chace',
  'chaco',
  'chads',
  'chafe',
  'chaff',
  'chaft',
  'chain',
  'chair',
  'chais',
  'chalk',
  'chals',
  'champ',
  'chams',
  'chang',
  'chank',
  'chant',
  'chaos',
  'chape',
  'chaps',
  'chapt',
  'chara',
  'chard',
  'chare',
  'chark',
  'charm',
  'charr',
  'chars',
  'chart',
  'chary',
  'chase',
  'chasm',
  'chats',
  'chaws',
  'chaya',
  'chays',
  'cheap',
  'cheat',
  'check',
  'cheek',
  'cheep',
  'cheer',
  'chefs',
  'cheka',
  'chela',
  'chemo',
  'chert',
  'chess',
  'chest',
  'cheth',
  'chevy',
  'chews',
  'chewy',
  "chi's",
  'chiao',
  'chias',
  'chica',
  'chich',
  'chick',
  'chico',
  'chics',
  'chide',
  'chief',
  'chiel',
  'chiks',
  'child',
  'chile',
  'chili',
  'chill',
  'chimb',
  'chime',
  'chimo',
  'chimp',
  'china',
  'chine',
  'ching',
  'chink',
  'chino',
  'chins',
  'chips',
  'chirk',
  'chirm',
  'chiro',
  'chirp',
  'chirr',
  'chirt',
  'chits',
  'chive',
  'chivs',
  'chivy',
  'chizz',
  'chock',
  'choco',
  'chocs',
  'choir',
  'choke',
  'choko',
  'choky',
  'chola',
  'choli',
  'cholo',
  'chomp',
  'choof',
  'chook',
  'choom',
  'chops',
  'chord',
  'chore',
  'chose',
  'chota',
  'chott',
  'chout',
  'choux',
  'chows',
  'chron',
  'chubs',
  'chuck',
  'chufa',
  'chuff',
  'chugs',
  'chump',
  'chums',
  'chunk',
  'churl',
  'churn',
  'churr',
  'chuse',
  'chute',
  'chuts',
  'chyle',
  'chyme',
  'ciaos',
  'cibol',
  'cider',
  'cigar',
  'cilia',
  'cills',
  'cimar',
  'cimex',
  'cinch',
  'cinct',
  'cines',
  'cions',
  'cippi',
  'circa',
  'circs',
  'cires',
  'cirls',
  'cirri',
  'cisco',
  'cists',
  'cital',
  'cited',
  'citer',
  'cites',
  'cives',
  'civet',
  'civic',
  'civie',
  'civil',
  'civvy',
  'clach',
  'clack',
  'clade',
  'clads',
  'claes',
  'clags',
  'claim',
  'clame',
  'clamp',
  'clams',
  'clang',
  'clank',
  'clans',
  'claps',
  'clapt',
  'claro',
  'clart',
  'clary',
  'clash',
  'clasp',
  'class',
  'clast',
  'clave',
  'clavi',
  'claws',
  'clays',
  'clean',
  'clear',
  'cleat',
  'cleck',
  'cleek',
  'clefs',
  'cleft',
  'clegs',
  'clems',
  'clepe',
  'clept',
  'clerk',
  'cleve',
  'clews',
  'click',
  'clied',
  'clies',
  'cliff',
  'clift',
  'climb',
  'clime',
  'cline',
  'cling',
  'clink',
  'clint',
  'clips',
  'clipt',
  'clits',
  'cloak',
  'cloam',
  'clock',
  'clods',
  'cloff',
  'clogs',
  'cloke',
  'clomb',
  'clomp',
  'clone',
  'clonk',
  'clons',
  'cloop',
  'cloot',
  'clops',
  'close',
  'clote',
  'cloth',
  'clots',
  'cloud',
  'clour',
  'clous',
  'clout',
  'clove',
  'clown',
  'clows',
  'cloys',
  'cloze',
  'clubs',
  'cluck',
  'clued',
  'clues',
  'clump',
  'clung',
  'clunk',
  'clvii',
  'clxii',
  'clxiv',
  'clxix',
  'clxvi',
  'clype',
  'cnida',
  'coach',
  'coact',
  'coala',
  'coals',
  'coaly',
  'coapt',
  'coarb',
  'coast',
  'coati',
  'coats',
  "cob's",
  'cobbs',
  'cobby',
  'cobia',
  'coble',
  'cobra',
  'cobza',
  'cocas',
  'cocci',
  'cocco',
  'cocks',
  'cocky',
  'cocoa',
  'cocos',
  "cod's",
  'codas',
  'codec',
  'coded',
  'coden',
  'coder',
  'codes',
  'codex',
  'codon',
  'coeds',
  'coffs',
  "cog's",
  'cogie',
  'cogon',
  'cogue',
  'cohab',
  'cohen',
  'cohoe',
  'cohog',
  'cohos',
  'coifs',
  'coign',
  'coils',
  'coins',
  'coirs',
  'coked',
  'cokes',
  "col's",
  'colas',
  'colby',
  'colds',
  'coled',
  'coles',
  'coley',
  'colic',
  'colin',
  'colly',
  'colog',
  'colon',
  'color',
  'colts',
  'colza',
  'comae',
  'comal',
  'comas',
  'combe',
  'combo',
  'combs',
  'comby',
  'comdg',
  'comer',
  'comes',
  'comet',
  'comfy',
  'comic',
  'comix',
  'comma',
  'commo',
  'commy',
  'compo',
  'comps',
  'compt',
  'comte',
  'comus',
  "con's",
  'conch',
  'condo',
  'coned',
  'cones',
  'coney',
  'conga',
  'conge',
  'congo',
  'conia',
  'conic',
  'conin',
  'conks',
  'conky',
  'conns',
  'contd',
  'conte',
  'conto',
  'contr',
  'conus',
  'convo',
  "coo's",
  'cooch',
  'cooed',
  'cooee',
  'cooer',
  'cooey',
  'coofs',
  'cooks',
  'cooky',
  'cools',
  'cooly',
  'coomb',
  'cooms',
  'coomy',
  'coons',
  'coops',
  'coopt',
  'coost',
  'coots',
  "cop's",
  'copal',
  'copay',
  'coped',
  'copen',
  'coper',
  'copes',
  'coppy',
  'copra',
  'copse',
  'copsy',
  'coral',
  'coram',
  'corbe',
  'corby',
  'cords',
  'cored',
  'coreq',
  'corer',
  'cores',
  'corey',
  'corgi',
  'coria',
  'corks',
  'corky',
  'corms',
  'corni',
  'corno',
  'corns',
  'cornu',
  'corny',
  'corps',
  'corse',
  'corso',
  "cos's",
  'cosec',
  'cosed',
  'coses',
  'coset',
  'cosey',
  'cosie',
  'costa',
  'coste',
  'costs',
  "cot's",
  'cotan',
  'coted',
  'cotes',
  'coths',
  'cotta',
  'cotte',
  'cotts',
  'couch',
  'coude',
  'cough',
  'could',
  'count',
  'coupe',
  'coups',
  'courb',
  'court',
  'couth',
  'coved',
  'coven',
  'cover',
  'coves',
  'covet',
  'covey',
  'covin',
  "cow's",
  'cowal',
  'cowan',
  'cowed',
  'cower',
  'cowls',
  'cowps',
  'cowry',
  "cox's",
  'coxae',
  'coxal',
  'coxed',
  'coxes',
  'coyed',
  'coyer',
  'coyly',
  'coypu',
  'cozed',
  'cozen',
  'cozes',
  'cozey',
  'cozie',
  "cps's",
  'craal',
  'crabs',
  'crack',
  'craft',
  'crags',
  'craig',
  'crake',
  'cramp',
  'crams',
  'crane',
  'crank',
  'crans',
  'crape',
  'craps',
  'crapy',
  'crare',
  'crash',
  'crass',
  'crate',
  'crave',
  'crawl',
  'craws',
  'crays',
  'craze',
  'crazy',
  'creak',
  'cream',
  'credo',
  'creed',
  'creek',
  'creel',
  'creep',
  'crees',
  'creme',
  'crena',
  'crepe',
  'crept',
  'crepy',
  'cress',
  'crest',
  'crewe',
  'crews',
  'cribs',
  'crick',
  'cried',
  'crier',
  'cries',
  'crime',
  'crimp',
  'crine',
  'cripe',
  'crips',
  'crise',
  'crisp',
  'crith',
  'crits',
  'croak',
  'croci',
  'crock',
  'crocs',
  'croft',
  'crone',
  'cronk',
  'crony',
  'crook',
  'croon',
  'crops',
  'crore',
  'cross',
  'croup',
  'crout',
  'crowd',
  'crown',
  'crows',
  'croze',
  'cruck',
  'crude',
  'cruds',
  'crudy',
  'cruel',
  'cruet',
  'cruft',
  'crumb',
  'crump',
  'cruor',
  'crura',
  'cruse',
  'crush',
  'crust',
  'crwth',
  "cry's",
  'cryer',
  'crypt',
  'cryst',
  'ctene',
  "cub's",
  'cubby',
  'cubeb',
  'cubed',
  'cuber',
  'cubes',
  'cubic',
  'cubit',
  "cud's",
  'cuddy',
  "cue's",
  'cuffs',
  'cuifs',
  'cuing',
  'cuish',
  'cuits',
  'cukes',
  'culch',
  'culet',
  'culex',
  'culls',
  'cully',
  'culms',
  'culpa',
  'culti',
  'cults',
  "cum's",
  'cumec',
  'cumin',
  'cunts',
  "cup's",
  'cupel',
  'cupid',
  'cuppa',
  'cuppy',
  "cur's",
  'curat',
  'curbs',
  'curch',
  'curds',
  'curdy',
  'cured',
  'curer',
  'cures',
  'curet',
  'curfs',
  'curia',
  'curie',
  'curio',
  'curls',
  'curly',
  'curns',
  'currs',
  'curry',
  'curse',
  'cursi',
  'curst',
  'curve',
  'curvy',
  'cusec',
  'cushy',
  'cusks',
  'cusps',
  'cusso',
  "cut's",
  'cutch',
  'cuter',
  'cutes',
  'cutey',
  'cutie',
  'cutin',
  'cutis',
  'cutto',
  'cutty',
  'cutup',
  'cuvee',
  "cwm's",
  "cwt's",
  'cyano',
  'cyans',
  'cycad',
  'cycas',
  'cycle',
  'cyclo',
  'cylix',
  'cymae',
  'cymar',
  'cymas',
  'cymes',
  'cymol',
  'cynic',
  'cysts',
  'cytes',
  'cyton',
  'czars',
  'daals',
  "dab's",
  'daces',
  'dacha',
  "dad's",
  'dadas',
  'daddy',
  'dados',
  'daeva',
  'daffs',
  'daffy',
  "dag's",
  'dagga',
  'daggy',
  'dagos',
  "dah's",
  'dahls',
  'daily',
  'daint',
  'dairy',
  'daisy',
  "dak's",
  "dal's",
  'daled',
  'dales',
  'dalet',
  'dalis',
  'dalle',
  'dally',
  'dalts',
  "dam's",
  'daman',
  'damar',
  'dames',
  'damme',
  'damns',
  'damps',
  'dampy',
  'dance',
  'dancy',
  'dandy',
  'dangs',
  'danio',
  'daraf',
  'darbs',
  'darcy',
  'dared',
  'darer',
  'dares',
  'darga',
  'daric',
  'daris',
  'darks',
  'darky',
  'darns',
  'darts',
  'darzi',
  "das's",
  'dashi',
  'dashy',
  'datal',
  'dated',
  'dater',
  'dates',
  'datos',
  'datto',
  'datum',
  'daube',
  'daubs',
  'dauby',
  'dauds',
  'daunt',
  'dauts',
  'daven',
  'davit',
  "daw's",
  'dawed',
  'dawen',
  'dawks',
  'dawns',
  'dawts',
  "day's",
  'daynt',
  'dazed',
  'dazer',
  'dazes',
  'dding',
  'deads',
  'deair',
  'deals',
  'dealt',
  'deans',
  'deare',
  'dearn',
  'dears',
  'deary',
  'deash',
  'death',
  'deave',
  "deb's",
  'debag',
  'debar',
  'debby',
  'debel',
  'debit',
  'debts',
  'debud',
  'debug',
  'debus',
  'debut',
  'debye',
  'decad',
  'decaf',
  'decal',
  'decay',
  'decko',
  'decks',
  'decon',
  'decor',
  'decos',
  'decoy',
  'decry',
  'dedal',
  'deeds',
  'deedy',
  'deems',
  'deeps',
  'deere',
  'deers',
  'deets',
  'deevs',
  'defat',
  'defer',
  'defis',
  'defog',
  'degas',
  'degum',
  'deice',
  'deify',
  'deign',
  'deils',
  'deism',
  'deist',
  'deity',
  'deked',
  'dekes',
  'dekko',
  'delay',
  'deled',
  'deles',
  'delfs',
  'delft',
  'delis',
  'dells',
  'delly',
  'delph',
  'delta',
  'delts',
  'delve',
  'deman',
  'demes',
  'demic',
  'demit',
  'demob',
  'demon',
  'demos',
  'demur',
  "den's",
  'denar',
  'denay',
  'denes',
  'denim',
  'denom',
  'dense',
  'dents',
  'deoxy',
  'depot',
  'depth',
  'derat',
  'deray',
  'derby',
  'derib',
  'derig',
  'deriv',
  'derma',
  'derms',
  'derry',
  'derth',
  'desex',
  'desks',
  'desse',
  'deter',
  'detox',
  'deuce',
  'devas',
  'devel',
  'devil',
  'devon',
  'devot',
  "dew's",
  'dewan',
  'dewar',
  'dewax',
  'dewed',
  'dexes',
  'dexie',
  'dhaks',
  'dhals',
  'dhobi',
  'dhole',
  'dholl',
  'dhoti',
  'dhows',
  'dhuti',
  'diact',
  'dials',
  'diary',
  'diazo',
  'dibbs',
  'diced',
  'dicer',
  'dices',
  'dicey',
  'dicks',
  'dicky',
  'dicot',
  'dicta',
  'dicty',
  'diddy',
  'didie',
  'didos',
  'didst',
  "die's",
  'diebs',
  'diene',
  'diets',
  'diffs',
  "dig's",
  'dight',
  'digit',
  'dikas',
  'diked',
  'diker',
  'dikes',
  'dikey',
  'dildo',
  'dilli',
  'dills',
  'dilly',
  'dimer',
  'dimes',
  'dimly',
  "din's",
  'dinar',
  'dined',
  'diner',
  'dines',
  'dinge',
  'dingo',
  'dings',
  'dingy',
  'dinic',
  'dinks',
  'dinky',
  'dinos',
  'dints',
  'diode',
  'diols',
  'diota',
  "dip's",
  'diple',
  'dippy',
  'dipso',
  'direr',
  'dirge',
  'dirks',
  'dirls',
  'dirts',
  'dirty',
  "dis's",
  'disci',
  'disco',
  'discs',
  'dishy',
  'disks',
  'disme',
  'distr',
  "dit's",
  'dital',
  'ditas',
  'ditch',
  'dites',
  'ditsy',
  'ditto',
  'ditts',
  'ditty',
  'ditzy',
  'divan',
  'divas',
  'dived',
  'diver',
  'dives',
  'divot',
  'divvy',
  'diwan',
  'dixie',
  'dixit',
  'dizen',
  'dizzy',
  'djinn',
  'djins',
  "dkl's",
  'doabs',
  'doats',
  'dobby',
  'dobie',
  'dobla',
  'dobra',
  'dobro',
  "doc's",
  'docks',
  'doddy',
  'dodge',
  'dodgy',
  'dodos',
  "doe's",
  'doeks',
  'doers',
  'doest',
  'doeth',
  'doffs',
  "dog's",
  'doges',
  'dogey',
  'doggo',
  'doggy',
  'dogie',
  'dogma',
  "doh's",
  'dohyo',
  'doily',
  'doing',
  'doits',
  'dojos',
  "dol's",
  'dolce',
  'dolci',
  'doled',
  'doles',
  'dolia',
  'dolls',
  'dolly',
  'dolma',
  'dolor',
  'dolts',
  'domal',
  'domed',
  'domes',
  'domic',
  "don's",
  "don't",
  'donah',
  'donas',
  'donee',
  'donga',
  'dongs',
  'donna',
  'donne',
  'donor',
  'donsy',
  'donut',
  'doody',
  'dooks',
  'dools',
  'dooly',
  'dooms',
  'doomy',
  'doona',
  'doorn',
  'doors',
  'doozy',
  'dopas',
  'doped',
  'doper',
  'dopes',
  'dopey',
  'dorad',
  'doree',
  'dorks',
  'dorky',
  'dorms',
  'dormy',
  'dorps',
  'dorrs',
  'dorsa',
  'dorse',
  'dorts',
  'dorty',
  'dosed',
  'doseh',
  'doser',
  'doses',
  "dot's",
  'dotal',
  'doted',
  'doter',
  'dotes',
  'dotty',
  'douar',
  'doubt',
  'douce',
  'doucs',
  'dough',
  'doula',
  'douma',
  'doums',
  'doups',
  'doura',
  'douse',
  'douts',
  'doved',
  'doven',
  'dover',
  'doves',
  'dowar',
  'dowds',
  'dowdy',
  'dowed',
  'dowel',
  'dower',
  'dowie',
  'downa',
  'downs',
  'downy',
  'dowps',
  'dowry',
  'dowse',
  'doxie',
  'doyen',
  'doyly',
  'dozed',
  'dozen',
  'dozer',
  'dozes',
  'drabs',
  'drack',
  'draff',
  'draft',
  'drags',
  'drail',
  'drain',
  'drake',
  'drama',
  'drams',
  'drank',
  'drant',
  'drape',
  'draps',
  'drats',
  'drave',
  'drawl',
  'drawn',
  'draws',
  'drays',
  'dread',
  'dream',
  'drear',
  'dreck',
  'dreed',
  'drees',
  'dregs',
  'dreks',
  'drent',
  'dress',
  'drest',
  'dreys',
  'dribs',
  'dried',
  'drier',
  'dries',
  'drift',
  'drill',
  'drily',
  'drink',
  'drips',
  'dript',
  'drive',
  'droid',
  'droit',
  'drole',
  'droll',
  'drome',
  'drone',
  'drony',
  'droob',
  'droog',
  'drook',
  'drool',
  'droop',
  'drops',
  'dropt',
  'dross',
  'drouk',
  'drove',
  'drown',
  'drows',
  'drubs',
  'drugs',
  'druid',
  'drums',
  'drunk',
  'drupe',
  'druse',
  'drusy',
  'druxy',
  "dry's",
  'dryad',
  'dryer',
  'dryly',
  'dsobo',
  'dsomo',
  'duads',
  'duals',
  'duans',
  'duars',
  "dub's",
  'ducal',
  'ducat',
  'duces',
  'duchy',
  'ducks',
  'ducky',
  'ducts',
  "dud's",
  'duddy',
  'duded',
  'dudes',
  "due's",
  'duels',
  'duets',
  'duett',
  'duffs',
  'dufus',
  "dug's",
  'duits',
  'duked',
  'dukes',
  'dules',
  'dulia',
  'dulls',
  'dully',
  'dulse',
  'dumas',
  'dumbo',
  'dumbs',
  'dumka',
  'dumky',
  'dummy',
  'dumps',
  'dumpy',
  "dun's",
  'dunam',
  'dunce',
  'dunch',
  'dunes',
  'dungs',
  'dungy',
  'dunks',
  'dunno',
  'dunny',
  'dunts',
  "duo's",
  'duomi',
  'duomo',
  'duped',
  'duper',
  'dupes',
  'duple',
  'duply',
  'duppy',
  'dural',
  'duras',
  'dured',
  'dures',
  'durns',
  'duroc',
  'duros',
  'duroy',
  'durra',
  'durrs',
  'durst',
  'durum',
  'durzi',
  'dusks',
  'dusky',
  'dusts',
  'dusty',
  'dutch',
  'duvet',
  'duxes',
  'dwale',
  'dwalm',
  'dwams',
  'dwang',
  'dwarf',
  'dwaum',
  'dweeb',
  'dwell',
  'dwelt',
  'dwile',
  'dwine',
  'dyads',
  "dye's",
  'dyers',
  'dying',
  'dyked',
  'dykes',
  'dykey',
  'dynel',
  'dynes',
  'dzhos',
  'eager',
  'eagle',
  'eagre',
  "ear's",
  'eards',
  'eared',
  'earls',
  'early',
  'earns',
  'earth',
  'eased',
  'easel',
  'eases',
  'easle',
  'easts',
  'eaten',
  'eater',
  'eathe',
  'eaved',
  'eaves',
  "ebb's",
  'ebbed',
  'ebbet',
  'ebons',
  'ebony',
  'ebook',
  'ecads',
  'eched',
  'eches',
  'echos',
  'eclat',
  'ecrus',
  'edema',
  'edged',
  'edger',
  'edges',
  'edict',
  'edify',
  'edile',
  'edite',
  'edits',
  'educe',
  'educt',
  "eel's",
  'eerie',
  'effed',
  "eft's",
  'egads',
  'egers',
  'egest',
  "egg's",
  'eggar',
  'egged',
  'egger',
  "ego's",
  'egret',
  'ehing',
  'eider',
  'eidos',
  'eight',
  'eigne',
  'eikon',
  'eisel',
  'eject',
  'ejido',
  'eking',
  'ekkas',
  'elain',
  'eland',
  'elans',
  'elate',
  'elbow',
  'elchi',
  'elder',
  'eldin',
  'elect',
  'elegy',
  'elemi',
  "elf's",
  'elfin',
  'elide',
  'elint',
  'elite',
  "elk's",
  "ell's",
  "elm's",
  'elmen',
  'eloge',
  'elogy',
  'eloin',
  'elope',
  'elops',
  'elpee',
  'elsin',
  'elude',
  'elute',
  'elvan',
  'elver',
  'elves',
  'email',
  'embar',
  'embay',
  'embed',
  'ember',
  'embog',
  'embow',
  'embox',
  'embus',
  'emcee',
  'emeer',
  'emend',
  'emery',
  'emeus',
  "emf's",
  'emirs',
  'emits',
  'emmas',
  'emmer',
  'emmet',
  'emmew',
  'emmys',
  "emo's",
  'emoji',
  'emong',
  'emote',
  'empty',
  "emu's",
  'emule',
  'emure',
  'emyde',
  'emyds',
  'enact',
  'enami',
  'enate',
  "end's",
  'ended',
  'ender',
  'endew',
  'endow',
  'endue',
  'enema',
  'enemy',
  'enews',
  'enfix',
  'engin',
  'eniac',
  'enjoy',
  'enmew',
  'ennui',
  'enoki',
  'enols',
  'enorm',
  'enows',
  'enrol',
  'ensky',
  'ensue',
  'enter',
  'entia',
  'entry',
  'enure',
  'envoi',
  'envoy',
  'enzym',
  "eon's",
  'eorls',
  'eosin',
  'epact',
  'epees',
  'ephah',
  'ephas',
  'ephod',
  'ephor',
  'epics',
  'epoch',
  'epode',
  'epopt',
  'epoxy',
  'epris',
  'equal',
  'equid',
  'equip',
  'equiv',
  "era's",
  'erase',
  'erbia',
  'erect',
  "erg's",
  'ergon',
  'ergot',
  'erica',
  'erick',
  'erics',
  "ern's",
  'erned',
  'ernes',
  'erode',
  'erose',
  'erred',
  'error',
  'erses',
  'erubs',
  'eruct',
  'erugo',
  'erupt',
  'eruvs',
  'erven',
  'ervil',
  'esbat',
  'escar',
  'escot',
  'esile',
  'eskar',
  'esker',
  'esnes',
  "esp's",
  'essay',
  'esses',
  'ester',
  'estoc',
  'estop',
  'estro',
  "eta's",
  'etage',
  'etape',
  'etens',
  'ethal',
  'ether',
  'ethic',
  'ethos',
  'ethyl',
  'etnas',
  'ettin',
  'ettle',
  'etude',
  'etuis',
  'etwee',
  'etyma',
  'euges',
  'euked',
  'euois',
  'eupad',
  'euros',
  'eusol',
  'evade',
  "eve's",
  'evens',
  'event',
  'evert',
  'every',
  'evets',
  'evhoe',
  'evict',
  'evils',
  'evite',
  'evoes',
  'evohe',
  'evoke',
  "ewe's",
  'ewers',
  'ewked',
  'exact',
  'exalt',
  'exams',
  'excel',
  'exeat',
  'execs',
  'exert',
  'exies',
  'exile',
  'exine',
  'exing',
  'exist',
  'exits',
  'exode',
  'exons',
  'expat',
  'expel',
  'expos',
  'extol',
  'extra',
  'exude',
  'exuls',
  'exult',
  'exurb',
  'eyass',
  "eye's",
  'eyers',
  'eying',
  'eyots',
  'eyras',
  'eyres',
  'eyrie',
  'eyrir',
  'fable',
  'faced',
  'facer',
  'faces',
  'facet',
  'facia',
  'facks',
  'facts',
  "fad's",
  'faddy',
  'faded',
  'fader',
  'fades',
  'fadge',
  'fados',
  'faena',
  'faery',
  'faffs',
  "fag's",
  'faggy',
  'fagin',
  'fagot',
  'fails',
  'fains',
  'faint',
  'fairs',
  'fairy',
  'faith',
  'faked',
  'faker',
  'fakes',
  'fakey',
  'fakir',
  'falaj',
  'falls',
  'false',
  'famed',
  'fames',
  "fan's",
  'fanac',
  'fanal',
  'fancy',
  'fanes',
  'fanga',
  'fango',
  'fangs',
  'fanny',
  'fanon',
  'fanos',
  'fanum',
  'faqir',
  'farad',
  'farce',
  'farci',
  'farcy',
  'fards',
  'fared',
  'farer',
  'fares',
  'farle',
  'farls',
  'farms',
  'faros',
  'farse',
  'farts',
  'fasci',
  'fasti',
  'fasts',
  "fat's",
  'fatal',
  'fated',
  'fates',
  'fatly',
  'fatso',
  'fatty',
  'fatwa',
  'faugh',
  'fauld',
  'fault',
  'fauna',
  'fauns',
  'faurd',
  'fauve',
  'favas',
  'favel',
  'faves',
  'favor',
  'favus',
  'fawns',
  'fawny',
  "fax's",
  'faxed',
  'faxes',
  "fay's",
  'fayed',
  'fayer',
  'fayre',
  'fazed',
  'fazes',
  'feals',
  'feare',
  'fears',
  'fease',
  'feast',
  'feats',
  'feaze',
  'fecal',
  'feces',
  'fecht',
  'fecit',
  'fecks',
  "fed's",
  'fedex',
  "fee's",
  'feebs',
  'feeds',
  'feels',
  'feers',
  'feeze',
  'feign',
  'feint',
  'feist',
  'felid',
  'fella',
  'fells',
  'felly',
  'felon',
  'felts',
  'felty',
  'femes',
  'femme',
  'femur',
  "fen's",
  'fence',
  'fends',
  'fendy',
  'fenks',
  'fenny',
  'fents',
  'feods',
  'feoff',
  'feral',
  'feres',
  'feria',
  'ferie',
  'ferly',
  'fermi',
  'ferms',
  'ferns',
  'ferny',
  'ferry',
  'fesse',
  'festa',
  'fests',
  'fetal',
  'fetas',
  'fetch',
  'feted',
  'fetes',
  'fetid',
  'fetor',
  'fetta',
  'fetus',
  'fetwa',
  'feuar',
  'feuds',
  'feued',
  'fever',
  "few's",
  'fewer',
  'feyer',
  'feyly',
  "fez's",
  'fezes',
  'fezzy',
  'fiars',
  'fiats',
  "fib's",
  'fiber',
  'fibre',
  'fibro',
  'fices',
  'fiche',
  'fichu',
  'ficin',
  'ficos',
  'ficus',
  'fidge',
  'fidos',
  'fiefs',
  'field',
  'fiend',
  'fient',
  'fiere',
  'fiery',
  'fifed',
  'fifer',
  'fifes',
  'fifth',
  'fifty',
  "fig's",
  'fight',
  'figos',
  'filar',
  'filch',
  'filed',
  'filer',
  'files',
  'filet',
  'fille',
  'fillo',
  'fills',
  'filly',
  'filmi',
  'films',
  'filmy',
  'filos',
  'filth',
  'filum',
  "fin's",
  'final',
  'finca',
  'finch',
  'finds',
  'fined',
  'finer',
  'fines',
  'finis',
  'finks',
  'finny',
  'finos',
  'fiord',
  'fique',
  "fir's",
  'fired',
  'firer',
  'fires',
  'firms',
  'firns',
  'firry',
  'first',
  'firth',
  'fiscs',
  'fishy',
  'fisks',
  'fists',
  'fisty',
  "fit's",
  'fitch',
  'fitly',
  'fitte',
  'fitts',
  'fiver',
  'fives',
  "fix's",
  'fixed',
  'fixer',
  'fixes',
  'fixit',
  'fixup',
  'fizzy',
  'fjeld',
  'fjord',
  'flabs',
  'flack',
  'flags',
  'flail',
  'flair',
  'flake',
  'flaks',
  'flaky',
  'flame',
  'flams',
  'flamy',
  'flank',
  'flans',
  'flaps',
  'flare',
  'flary',
  'flash',
  'flask',
  'flats',
  'flawn',
  'flaws',
  'flawy',
  'flaxy',
  'flays',
  'fleam',
  'fleas',
  'fleck',
  'fleer',
  'flees',
  'fleet',
  'fleme',
  'flesh',
  'flews',
  'fleys',
  'flick',
  'flics',
  'flied',
  'flier',
  'flies',
  'flimp',
  'fling',
  'flint',
  'flips',
  'flirs',
  'flirt',
  'flisk',
  'flite',
  'flits',
  'float',
  'flock',
  'flocs',
  'floes',
  'flogs',
  'flong',
  'flood',
  'floor',
  'flops',
  'flora',
  'flory',
  'flosh',
  'floss',
  'flota',
  'flote',
  'flour',
  'flout',
  'flown',
  'flows',
  "flu's",
  'flubs',
  'flued',
  'fluer',
  'flues',
  'fluey',
  'fluff',
  'fluid',
  'fluke',
  'fluky',
  'flume',
  'flump',
  'flung',
  'flunk',
  'fluor',
  'flush',
  'flute',
  'fluty',
  'fluyt',
  "fly's",
  'flyby',
  'flyer',
  'flype',
  'flyte',
  'foals',
  'foams',
  'foamy',
  "fob's",
  'focal',
  'focus',
  "foe's",
  'foehn',
  "fog's",
  'fogey',
  'foggy',
  'fogie',
  'fogle',
  'fohns',
  'foils',
  'foins',
  'foist',
  'folds',
  'foley',
  'folia',
  'folic',
  'folie',
  'folio',
  'folks',
  'folky',
  'folly',
  'fomes',
  'fonda',
  'fonds',
  'fondu',
  'fonly',
  'fonts',
  'foods',
  'foody',
  'fools',
  'foons',
  'foots',
  'footy',
  "fop's",
  'foram',
  'foray',
  'forbs',
  'forby',
  'force',
  'fordo',
  'fords',
  'forel',
  'fores',
  'forge',
  'forgo',
  'forks',
  'forky',
  'forme',
  'forms',
  'forte',
  'forth',
  'forts',
  'forty',
  'forum',
  'fossa',
  'fosse',
  'fouds',
  'foule',
  'fouls',
  'fount',
  'fourb',
  'fours',
  'fouth',
  'fovea',
  'fowls',
  "fox's",
  'foxed',
  'foxes',
  'foyer',
  'frack',
  'fract',
  'frags',
  'frail',
  'frame',
  'franc',
  'frank',
  'fraps',
  'frass',
  'frate',
  'frati',
  'frats',
  'fraud',
  'fraus',
  'frays',
  'freak',
  'freed',
  'freer',
  'frees',
  'freet',
  'freit',
  'fremd',
  'frena',
  'frere',
  'fresh',
  'fress',
  'frets',
  'friar',
  'fried',
  'frier',
  'fries',
  'frigs',
  'frill',
  'frise',
  'frisk',
  'frist',
  'frith',
  'frits',
  'fritt',
  'fritz',
  'frize',
  'frizz',
  "fro's",
  'frock',
  'froes',
  'frogs',
  'frond',
  'frons',
  'front',
  'frore',
  'frorn',
  'frory',
  'frosh',
  'frost',
  'froth',
  'frown',
  'frows',
  'frowy',
  'froze',
  'frugs',
  'fruit',
  'frump',
  'frust',
  "fry's",
  'fryer',
  "ftp's",
  'ftped',
  'fubar',
  'fubby',
  'fubsy',
  'fucks',
  'fucus',
  'fuddy',
  'fudge',
  'fuels',
  'fuero',
  'fufus',
  "fug's",
  'fugal',
  'fuggy',
  'fugie',
  'fugio',
  'fugle',
  'fugly',
  'fugue',
  'fugus',
  'fujis',
  'fulls',
  'fully',
  'fumed',
  'fumer',
  'fumes',
  'fumet',
  "fun's",
  'fundi',
  'funds',
  'fundy',
  'fungi',
  'fungo',
  'fungs',
  'funks',
  'funky',
  'funny',
  "fur's",
  'fural',
  'furan',
  'furls',
  'furol',
  'furor',
  'furos',
  'furry',
  'furth',
  'furze',
  'furzy',
  'fused',
  'fusee',
  'fusel',
  'fuses',
  'fusil',
  'fussy',
  'fusts',
  'fusty',
  'futon',
  'fuzed',
  'fuzee',
  'fuzes',
  'fuzil',
  'fuzzy',
  'fyces',
  'fykes',
  'fyrds',
  'fytte',
  "g'day",
  "gab's",
  'gabby',
  'gable',
  "gad's",
  'gaddi',
  'gades',
  'gadge',
  'gadid',
  'gadis',
  'gadso',
  'gaffe',
  'gaffs',
  "gag's",
  'gaged',
  'gager',
  'gages',
  'gaids',
  'gaily',
  'gains',
  'gairs',
  'gaits',
  'gajos',
  "gal's",
  'galah',
  'galas',
  'galax',
  'galea',
  'galee',
  'gales',
  'galls',
  'gally',
  'galop',
  'galut',
  'gamas',
  'gamay',
  'gamba',
  'gambe',
  'gambo',
  'gambs',
  'gamed',
  'gamer',
  'games',
  'gamey',
  'gamic',
  'gamin',
  'gamma',
  'gamme',
  'gammy',
  'gamps',
  'gamut',
  'ganch',
  'ganef',
  'ganev',
  'gangs',
  'ganja',
  'ganof',
  'gants',
  'gaols',
  "gap's",
  'gaped',
  'gaper',
  'gapes',
  'gapos',
  'gappy',
  "gar's",
  'garbe',
  'garbo',
  'garbs',
  'garda',
  'garni',
  'garth',
  'garum',
  "gas's",
  'gases',
  'gasps',
  'gaspy',
  'gassy',
  'gasts',
  "gat's",
  'gated',
  'gater',
  'gates',
  'gator',
  'gauds',
  'gaudy',
  'gauge',
  'gault',
  'gaums',
  'gaumy',
  'gaunt',
  'gaups',
  'gaurs',
  'gauss',
  'gauze',
  'gauzy',
  'gavel',
  'gavot',
  'gawks',
  'gawky',
  'gawps',
  'gawsy',
  "gay's",
  'gayal',
  'gayer',
  'gayly',
  'gazal',
  'gazar',
  'gazed',
  'gazel',
  'gazer',
  'gazes',
  'gazon',
  'gazoo',
  'geals',
  'geans',
  'geare',
  'gears',
  'geats',
  'gebel',
  'gebur',
  'gecko',
  'gecks',
  "gee's",
  'geeks',
  'geeky',
  'geese',
  'geest',
  'geist',
  "gel's",
  'gelds',
  'gelee',
  'gelid',
  'gelly',
  'gelts',
  "gem's",
  'gemel',
  'gemma',
  'gemmy',
  'gemot',
  "gen's",
  'genal',
  'genas',
  'genes',
  'genet',
  'genic',
  'genie',
  'genii',
  'genip',
  'genit',
  'genoa',
  'genom',
  'genre',
  'genro',
  'gents',
  'genty',
  'genua',
  'genus',
  'geode',
  'geoid',
  'gerah',
  'gerbe',
  'germs',
  'germy',
  'gesso',
  'geste',
  'gests',
  'getas',
  'getgo',
  'getup',
  'geums',
  'geyan',
  'ghast',
  'ghats',
  'ghaut',
  'ghazi',
  'ghees',
  'ghost',
  'ghoul',
  'ghyll',
  'giant',
  'gibed',
  'gibel',
  'giber',
  'gibes',
  'gibus',
  'giddy',
  'gifts',
  "gig's",
  'gigas',
  'gighe',
  'gigot',
  'gigue',
  'gilas',
  'gilds',
  'gilet',
  'gills',
  'gilly',
  'gilpy',
  'gilts',
  'gimel',
  'gimme',
  'gimps',
  'gimpy',
  "gin's",
  'ginks',
  'ginny',
  'ginzo',
  'gipon',
  'gippo',
  'gippy',
  'gipsy',
  'girds',
  'giris',
  'girls',
  'girly',
  'girns',
  'giron',
  'giros',
  'girrs',
  'girsh',
  'girth',
  'girts',
  'gismo',
  'gists',
  'gites',
  'giust',
  'givee',
  'giver',
  'gives',
  'gizmo',
  'glace',
  'glade',
  'glads',
  'glady',
  'glaik',
  'glair',
  'glams',
  'gland',
  'glans',
  'glare',
  'glary',
  'glass',
  'glaur',
  'glaze',
  'glazy',
  'gleam',
  'glean',
  'gleba',
  'glebe',
  'gleby',
  'glede',
  'gleds',
  'gleed',
  'gleek',
  'glees',
  'gleet',
  'gleis',
  'glens',
  'gleys',
  'glial',
  'glias',
  'glide',
  'gliff',
  'glike',
  'glime',
  'glims',
  'glint',
  'glisk',
  'glitz',
  'gloam',
  'gloat',
  'globe',
  'globs',
  'globy',
  'glogg',
  'gloms',
  'gloom',
  'gloop',
  'glops',
  'glory',
  'gloss',
  'glost',
  'glout',
  'glove',
  'glows',
  'gloze',
  'glued',
  'gluer',
  'glues',
  'gluey',
  'glugs',
  'glume',
  'glums',
  'gluon',
  'glute',
  'gluts',
  'glyph',
  'gnarl',
  'gnarr',
  'gnars',
  'gnash',
  'gnats',
  'gnawn',
  'gnaws',
  'gnome',
  "gnu's",
  'goads',
  'goafs',
  'goals',
  'goats',
  'goaty',
  "gob's",
  'goban',
  'gobbi',
  'gobbo',
  'gobos',
  "god's",
  'godet',
  'godly',
  'goels',
  'goers',
  'goety',
  'gofer',
  'goffs',
  'gogos',
  'going',
  'golds',
  'goldy',
  'golem',
  'golfs',
  'golly',
  'golpe',
  'golps',
  'gombo',
  'gomer',
  'gompa',
  'gonad',
  'gonef',
  'goner',
  'gongs',
  'gonia',
  'gonif',
  'gonks',
  'gonna',
  'gonof',
  'gonys',
  'gonzo',
  "goo's",
  'goods',
  'goody',
  'gooey',
  'goofs',
  'goofy',
  'googs',
  'gooks',
  'gooky',
  'gools',
  'gooly',
  'goons',
  'goony',
  'goops',
  'goopy',
  'goose',
  'goosy',
  'gopak',
  'gopik',
  'goral',
  'gored',
  'gores',
  'gorge',
  'gorks',
  'gorms',
  'gorps',
  'gorse',
  'gorsy',
  'gosht',
  'goths',
  'gotta',
  'gouge',
  'gourd',
  'gouts',
  'gouty',
  'gowan',
  'gowds',
  'gowks',
  'gowls',
  'gowns',
  'goxes',
  "goy's",
  'goyim',
  'graal',
  'grabs',
  'grace',
  'grade',
  'grads',
  'graft',
  'grail',
  'grain',
  'graip',
  'grama',
  'grame',
  'gramp',
  'grams',
  'grana',
  'grand',
  'grans',
  'grant',
  'grape',
  'graph',
  'grapy',
  'grasp',
  'grass',
  'grate',
  'grave',
  'gravs',
  'gravy',
  'grays',
  'graze',
  'great',
  'grebe',
  'grece',
  'greed',
  'greek',
  'green',
  'grees',
  'greet',
  'grege',
  'grego',
  'greps',
  'grese',
  'greve',
  'greys',
  'grice',
  'gride',
  'grids',
  'grief',
  'griff',
  'grift',
  'grigs',
  'grike',
  'grill',
  'grime',
  'grimy',
  'grind',
  'grins',
  'griot',
  'gripe',
  'grips',
  'gript',
  'gripy',
  'grise',
  'grist',
  'grisy',
  'grith',
  'grits',
  'grize',
  'groan',
  'groat',
  'grody',
  'grogs',
  'groin',
  'groks',
  'groma',
  'groof',
  'groom',
  'grope',
  'gross',
  'grosz',
  'grots',
  'grouf',
  'group',
  'grout',
  'grove',
  'growl',
  'grown',
  'grows',
  'grubs',
  'grued',
  'gruel',
  'grues',
  'gruff',
  'grume',
  'grump',
  'grunt',
  'gryke',
  'guaco',
  'guana',
  'guano',
  'guans',
  'guard',
  'guars',
  'guava',
  'gucks',
  'gucky',
  'gudes',
  'guess',
  'guest',
  'guffs',
  'gugas',
  'guide',
  'guids',
  'guild',
  'guile',
  'guilt',
  'guimp',
  'guiro',
  'guise',
  'gulae',
  'gulag',
  'gular',
  'gulas',
  'gulch',
  'gules',
  'gulfs',
  'gulfy',
  'gulls',
  'gully',
  'gulph',
  'gulps',
  'gulpy',
  "gum's",
  'gumbo',
  'gumma',
  'gummy',
  'gumps',
  "gun's",
  'gunda',
  'gundy',
  'gunge',
  'gungy',
  'gunks',
  'gunky',
  'gunny',
  'guppy',
  'gurge',
  'gurns',
  'gurry',
  'gursh',
  'gurus',
  'gushy',
  'gusla',
  'gusle',
  'gusli',
  'gussy',
  'gusto',
  'gusts',
  'gusty',
  "gut's",
  'gutsy',
  'gutta',
  'gutte',
  'gutty',
  "guy's",
  'guyed',
  'guyot',
  'gwine',
  'gyals',
  'gybed',
  'gybes',
  "gym's",
  'gymps',
  'gynae',
  'gyoza',
  "gyp's",
  'gyppo',
  'gypsy',
  'gyral',
  'gyred',
  'gyres',
  'gyron',
  'gyros',
  'gyrus',
  'gytes',
  'gyved',
  'gyves',
  "ha'it",
  'haafs',
  'haars',
  'habit',
  'hable',
  'habus',
  'hacek',
  'hacks',
  'hadal',
  'haded',
  'hades',
  'hadji',
  'hadst',
  'haems',
  'haets',
  'haffs',
  'hafis',
  'hafiz',
  'hafts',
  "hag's",
  'hahas',
  'haick',
  'haika',
  'haiks',
  'haiku',
  'hails',
  'haily',
  'haint',
  'hairs',
  'hairy',
  'haith',
  "haj's",
  'hajes',
  'hajis',
  'hajji',
  'hakam',
  'hakas',
  'hakes',
  'hakim',
  'hakus',
  'halal',
  'haled',
  'haler',
  'hales',
  'halfa',
  'halfs',
  'halid',
  'hallo',
  'halls',
  'halma',
  'halms',
  'halon',
  'halos',
  'halts',
  'halva',
  'halve',
  "ham's",
  'hamal',
  'hamba',
  'hames',
  'hammy',
  'hamza',
  "han't",
  'hanap',
  'hance',
  'hands',
  'handy',
  'hangs',
  'hanks',
  'hanky',
  'hansa',
  'hanse',
  'hants',
  "hao's",
  'haole',
  'haoma',
  "hap's",
  'hapax',
  'haply',
  'happy',
  'haram',
  'hards',
  'hardy',
  'hared',
  'harem',
  'hares',
  'harim',
  'harks',
  'harls',
  'harms',
  'harns',
  'harps',
  'harpy',
  'harry',
  'harsh',
  'harts',
  'hashy',
  'hasps',
  'hasta',
  'haste',
  'hasty',
  "hat's",
  'hatch',
  'hated',
  'hater',
  'hates',
  'hauds',
  'haugh',
  'hauld',
  'haulm',
  'hauls',
  'hault',
  'haunt',
  'hause',
  'haute',
  'haven',
  'haver',
  'haves',
  'havoc',
  "haw's",
  'hawed',
  'hawks',
  'hawse',
  "hay's",
  'hayed',
  'hayer',
  'hayey',
  'hayle',
  'hazan',
  'hazed',
  'hazel',
  'hazer',
  'hazes',
  'hdqrs',
  "he'll",
  'heads',
  'heady',
  'heald',
  'heals',
  'heaps',
  'heapy',
  'heard',
  'heare',
  'hears',
  'heart',
  'heath',
  'heats',
  'heave',
  'heavy',
  'heben',
  'hebes',
  'hechs',
  'hecks',
  'heder',
  'hedge',
  'hedgy',
  'heeds',
  'heedy',
  'heels',
  'heeze',
  'hefts',
  'hefty',
  'heids',
  'heigh',
  'heils',
  'heirs',
  'heist',
  'hejab',
  'hejra',
  'helio',
  'helis',
  'helix',
  'hello',
  'hells',
  'helms',
  'helos',
  'helot',
  'helps',
  'helve',
  "hem's",
  'hemal',
  'heman',
  'hemen',
  'hemes',
  'hemic',
  'hemin',
  'hemps',
  'hempy',
  "hen's",
  'hence',
  'henge',
  'henna',
  'henny',
  'henry',
  'hents',
  'hepar',
  'herbs',
  'herby',
  'herds',
  'herem',
  'heres',
  'herls',
  'herma',
  'herms',
  'herns',
  'heron',
  'heros',
  'herry',
  'herse',
  'hertz',
  'hests',
  'heths',
  'heuch',
  'heugh',
  'hevea',
  'hewed',
  'hewer',
  'hewgh',
  "hex's",
  'hexad',
  'hexed',
  'hexer',
  'hexes',
  'hexyl',
  'heyed',
  'hiant',
  'hicks',
  'hided',
  'hider',
  'hides',
  'hiems',
  'hiera',
  'highs',
  'hight',
  'hijab',
  'hijra',
  'hiked',
  'hiker',
  'hikes',
  'hilar',
  'hillo',
  'hills',
  'hilly',
  'hilts',
  'hilum',
  'hilus',
  "hin's",
  'hinds',
  'hinge',
  'hings',
  'hinny',
  'hints',
  "hip's",
  'hiply',
  'hippo',
  'hippy',
  'hired',
  'hiree',
  'hirer',
  'hires',
  "his's",
  'hissy',
  'hists',
  "hit's",
  'hitch',
  'hithe',
  'hived',
  'hiver',
  'hives',
  'hiyas',
  'hoagy',
  'hoard',
  'hoars',
  'hoary',
  'hoast',
  "hob's",
  'hobby',
  'hobos',
  'hocks',
  'hocus',
  "hod's",
  'hodad',
  'hodja',
  "hoe's",
  'hoers',
  "hog's",
  'hogan',
  'hogen',
  'hoggs',
  'hoick',
  'hoiks',
  'hoise',
  'hoist',
  'hoked',
  'hokes',
  'hokey',
  'hokku',
  'hokum',
  'holds',
  'holed',
  'holes',
  'holey',
  'holks',
  'holla',
  'hollo',
  'holly',
  'holme',
  'holms',
  'holts',
  'homed',
  'homer',
  'homes',
  'homey',
  'homie',
  'homme',
  'homos',
  "hon's",
  'honan',
  'honda',
  'honed',
  'honer',
  'hones',
  'honey',
  'hongi',
  'hongs',
  'honks',
  'honky',
  'honor',
  'hooch',
  'hoods',
  'hoody',
  'hooey',
  'hoofs',
  'hooka',
  'hooks',
  'hooky',
  'hooly',
  'hoons',
  'hoops',
  'hoosh',
  'hoots',
  'hooty',
  'hoove',
  "hop's",
  'hoped',
  'hoper',
  'hopes',
  'hoppy',
  'horae',
  'horah',
  'horal',
  'horas',
  'horde',
  'horme',
  'horns',
  'horny',
  'horol',
  'horse',
  'horst',
  'horsy',
  'hosed',
  'hosel',
  'hosen',
  'hoser',
  'hoses',
  'hosey',
  'hosta',
  'hosts',
  'hotch',
  'hotel',
  'hoten',
  'hotly',
  'hough',
  'hound',
  'houri',
  'hours',
  'house',
  'houts',
  'hovel',
  'hoven',
  'hover',
  "how'd",
  "how's",
  'howdy',
  'howes',
  'howff',
  'howfs',
  'howks',
  'howls',
  'howso',
  "hoy's",
  'hoyas',
  'hoyed',
  'hoyle',
  'huaca',
  "hub's",
  'hubby',
  'hucks',
  "hue's",
  'huffs',
  'huffy',
  "hug's",
  'huger',
  'huias',
  'huies',
  'hulas',
  'hules',
  'hulks',
  'hulky',
  'hulls',
  'hully',
  "hum's",
  'human',
  'humas',
  'humfs',
  'humic',
  'humid',
  'humor',
  'humph',
  'humps',
  'humpy',
  'humus',
  'hunch',
  'hunks',
  'hunky',
  'hunts',
  'hupot',
  'hurds',
  'hurls',
  'hurly',
  'hurra',
  'hurry',
  'hurst',
  'hurts',
  'hushy',
  'husks',
  'husky',
  'husos',
  'hussy',
  "hut's",
  'hutch',
  'hutia',
  'huzza',
  'hwyls',
  'hydra',
  'hydro',
  'hyena',
  'hying',
  'hykes',
  'hylas',
  'hyleg',
  'hylic',
  'hymen',
  'hymns',
  'hynde',
  'hyoid',
  'hyped',
  'hyper',
  'hypes',
  'hypha',
  'hypos',
  'hyrax',
  'hyson',
  'hythe',
  'iambi',
  'iambs',
  "ice's",
  'icers',
  'ichor',
  'icier',
  'icily',
  'icing',
  'icker',
  'icons',
  'ictal',
  'ictic',
  'ictus',
  'idant',
  'ideal',
  'ideas',
  'idest',
  'idiom',
  'idiot',
  'idled',
  'idler',
  'idles',
  'idols',
  'idyll',
  'idyls',
  'igads',
  'igapo',
  'igged',
  'igloo',
  'iglus',
  'ihram',
  'iiwis',
  'ikats',
  'ikons',
  'ileac',
  'ileal',
  'ileum',
  'ileus',
  'iliac',
  'iliad',
  'ilial',
  'ilium',
  "ilk's",
  "ill's",
  'iller',
  'illth',
  'illus',
  'image',
  'imago',
  'imams',
  'imari',
  'imaum',
  'imbed',
  'imbue',
  'imide',
  'imido',
  'imids',
  'imine',
  'imino',
  'immew',
  'immit',
  'immix',
  "imp's",
  'imped',
  'impel',
  'imper',
  'impis',
  'imply',
  'impot',
  'imshi',
  'imshy',
  'inane',
  'inapt',
  'inarm',
  'inbox',
  'inbye',
  'inced',
  'incle',
  'incog',
  'incur',
  'incus',
  'incut',
  'indef',
  'indew',
  'index',
  'indic',
  'indie',
  'indol',
  'indow',
  'indri',
  'induc',
  'indue',
  'inept',
  'inerm',
  'inert',
  'ineye',
  'infer',
  'infin',
  'infix',
  'infos',
  'infra',
  'ingan',
  'ingle',
  'ingot',
  'inion',
  "ink's",
  'inked',
  'inker',
  'inkle',
  'inlaw',
  'inlay',
  'inlet',
  "inn's",
  'inned',
  'inner',
  'innit',
  'inone',
  'inorb',
  'inorg',
  'input',
  'inset',
  'instr',
  'intel',
  'inter',
  'intil',
  'intis',
  'intro',
  'inula',
  'inure',
  'inurn',
  'inust',
  'invar',
  'inwit',
  'ioctl',
  'iodic',
  'iodid',
  'iodin',
  "ion's",
  'ionic',
  'iotas',
  'ippon',
  'irade',
  'irate',
  "ire's",
  'irids',
  'iring',
  'irked',
  'iroko',
  'irone',
  'irons',
  'irony',
  'irreg',
  'isbas',
  'ishes',
  'isled',
  'isles',
  'islet',
  "ism's",
  "isn't",
  'issei',
  'issue',
  'istle',
  "it'll",
  'itchy',
  'items',
  'ither',
  'ivied',
  'ivies',
  'ivory',
  "ivy's",
  'ixias',
  'ixora',
  'ixtle',
  'izard',
  'izars',
  'izbas',
  'izzat',
  "jab's",
  'jabot',
  'jacal',
  'jacks',
  'jacky',
  'jaded',
  'jades',
  "jag's",
  'jager',
  'jaggs',
  'jaggy',
  'jagir',
  'jagra',
  'jails',
  "jak's",
  'jakes',
  'jalap',
  'jalop',
  "jam's",
  'jambe',
  'jambo',
  'jambs',
  'jambu',
  'james',
  'jammy',
  'janes',
  'janty',
  'japan',
  'japed',
  'japer',
  'japes',
  "jar's",
  'jaris',
  'jarks',
  'jarls',
  'jarul',
  'jasey',
  'jaspe',
  'jatos',
  'jauks',
  'jaunt',
  'jaups',
  'javas',
  'javel',
  "jaw's",
  'jawan',
  'jawed',
  "jay's",
  'jazzy',
  'jeans',
  'jebel',
  'jeely',
  'jeeps',
  'jeers',
  'jefes',
  'jeffs',
  'jehad',
  'jehus',
  'jelab',
  'jello',
  'jells',
  'jelly',
  'jemmy',
  'jenny',
  'jerid',
  'jerks',
  'jerky',
  'jerry',
  'jesse',
  'jests',
  "jet's",
  'jetes',
  'jeton',
  'jetty',
  'jeune',
  'jewed',
  'jewel',
  'jhala',
  'jiaos',
  "jib's",
  'jibbs',
  'jibed',
  'jiber',
  'jibes',
  'jiffs',
  'jiffy',
  "jig's",
  'jiggy',
  'jigot',
  'jihad',
  'jills',
  'jilts',
  'jimmy',
  'jimpy',
  'jingo',
  'jinks',
  'jinni',
  'jinns',
  'jirds',
  'jirga',
  'jisms',
  'jived',
  'jiver',
  'jives',
  'jivey',
  'jnana',
  "job's",
  'jobed',
  'jobes',
  'jocko',
  'jocks',
  'jodel',
  'joeys',
  "jog's",
  'johns',
  'joins',
  'joint',
  'joist',
  'joked',
  'joker',
  'jokes',
  'jokey',
  'joled',
  'joles',
  'jolls',
  'jolly',
  'jolts',
  'jolty',
  'jomos',
  'jones',
  'jonty',
  'jooal',
  'jooks',
  'joram',
  'jorum',
  "jot's",
  'jotas',
  'jotty',
  'jotun',
  'joual',
  'jougs',
  'jouks',
  'joule',
  'joust',
  'jowar',
  'jowed',
  'jowls',
  'jowly',
  "joy's",
  'joyed',
  'jubas',
  'jubes',
  'judas',
  'judge',
  'judos',
  "jug's",
  'jugal',
  'jugum',
  'juice',
  'juicy',
  'jujus',
  'juked',
  'jukes',
  'jukus',
  'julep',
  'jumar',
  'jumbo',
  'jumby',
  'jumps',
  'jumpy',
  'junco',
  'junks',
  'junky',
  'junta',
  'junto',
  'jupes',
  'jupon',
  'jural',
  'jurat',
  'jurel',
  'juror',
  'justs',
  "jut's",
  'jutes',
  'jutty',
  'juves',
  'juvie',
  'kaama',
  'kabab',
  'kabar',
  'kabob',
  'kacha',
  'kades',
  'kadis',
  'kafir',
  'kagos',
  'kagus',
  'kahal',
  'kaiak',
  'kaids',
  'kaifs',
  'kails',
  'kaims',
  'kains',
  'kakas',
  'kakis',
  'kalam',
  'kales',
  'kalif',
  'kalis',
  'kalpa',
  'kamas',
  'kames',
  'kamik',
  'kamis',
  'kanae',
  'kanas',
  'kandy',
  'kaneh',
  'kanes',
  'kanga',
  'kangs',
  'kanji',
  'kants',
  'kanzu',
  'kaons',
  'kapas',
  'kaphs',
  'kapok',
  'kappa',
  'kaput',
  'karas',
  'karat',
  'karma',
  'karns',
  'karoo',
  'karri',
  'karst',
  'karsy',
  'karts',
  'karzy',
  'kasha',
  'katas',
  'katis',
  'katti',
  'kauri',
  'kaury',
  'kavas',
  'kavya',
  'kawed',
  'kayak',
  'kayle',
  'kayos',
  'kazis',
  'kazoo',
  'kbars',
  "kea's",
  'kebab',
  'kebar',
  'kebob',
  'kecks',
  'kedge',
  'keech',
  'keefs',
  'keeks',
  'keels',
  'keens',
  'keeps',
  'keets',
  'keeve',
  'kefir',
  "keg's",
  'keirs',
  'kelep',
  'kelim',
  'kells',
  'kelly',
  'kelps',
  'kelpy',
  'kelts',
  'kelty',
  'kembo',
  'kemps',
  'kempt',
  'kempy',
  "ken's",
  'kenaf',
  'kench',
  'kendo',
  'kenno',
  'kenos',
  'kente',
  'kents',
  'kepis',
  'kerbs',
  'kerfs',
  'kerne',
  'kerns',
  'kerry',
  'kerve',
  'kesar',
  'ketas',
  'ketch',
  'ketol',
  'kevel',
  'kevil',
  'kexes',
  "key's",
  'keyed',
  'khadi',
  'khafs',
  'khaki',
  'khans',
  'khaph',
  'khats',
  'khaya',
  'kheda',
  'kheth',
  'khets',
  'khoja',
  'khors',
  'khoum',
  'khuds',
  'kiack',
  'kiang',
  'kibbe',
  'kibbi',
  'kibei',
  'kibes',
  'kibla',
  'kicks',
  'kicky',
  "kid's",
  'kiddo',
  'kiddy',
  'kidel',
  'kideo',
  'kiefs',
  'kiers',
  'kieve',
  'kikes',
  'kikoi',
  'kiley',
  'kilim',
  'kills',
  'killy',
  'kilns',
  'kilos',
  'kilps',
  'kilts',
  'kilty',
  'kimbo',
  "kin's",
  'kinas',
  'kinda',
  'kinds',
  'kindy',
  'kines',
  'kings',
  'kinin',
  'kinks',
  'kinky',
  'kinos',
  'kiosk',
  "kip's",
  'kipes',
  'kippa',
  'kipps',
  'kirns',
  'kiruv',
  'kisan',
  'kissy',
  'kists',
  "kit's",
  'kited',
  'kiter',
  'kites',
  'kithe',
  'kiths',
  'kitty',
  'kivas',
  'kiwis',
  'klang',
  'klick',
  'kliks',
  'klong',
  'kloof',
  'kluge',
  'klutz',
  'knack',
  'knags',
  'knaps',
  'knarl',
  'knars',
  'knaur',
  'knave',
  'knawe',
  'knead',
  'kneed',
  'kneel',
  'knees',
  'knell',
  'knelt',
  'knife',
  'knish',
  'knits',
  'knive',
  'knobs',
  'knock',
  'knoll',
  'knops',
  'knosp',
  'knots',
  'knout',
  'knowe',
  'known',
  'knows',
  'knubs',
  'knurl',
  'knurr',
  'knurs',
  'knuts',
  'koala',
  'koans',
  "kob's",
  'koban',
  'kobos',
  'koels',
  'koffs',
  'kofta',
  'kohls',
  'koine',
  'kojis',
  'koker',
  'kokra',
  'kokum',
  'kolas',
  'kolos',
  'kombu',
  'konks',
  'kooks',
  'kooky',
  'koori',
  'kopek',
  'kophs',
  'kopje',
  'koppa',
  "kor's",
  'korai',
  'koras',
  'korat',
  'kores',
  'korma',
  'korun',
  "kos's",
  'koses',
  'kotos',
  'kotow',
  "kph's",
  'kraal',
  'krabs',
  'kraft',
  'krait',
  'krams',
  'krang',
  'krans',
  'kranz',
  'kraut',
  'kreep',
  'kreng',
  'krewe',
  'krill',
  'krona',
  'krone',
  'kroon',
  'krubi',
  'ksars',
  'kudos',
  'kudus',
  'kudzu',
  'kugel',
  'kukri',
  'kukus',
  'kulak',
  'kulan',
  'kumys',
  'kunas',
  'kuris',
  'kurta',
  'kurus',
  'kusso',
  'kutch',
  'kvass',
  'kvell',
  'kwela',
  'kyack',
  'kyaks',
  'kyang',
  'kyars',
  'kyats',
  'kyles',
  'kylie',
  'kylin',
  'kylix',
  'kyloe',
  'kyrie',
  'kytes',
  'kythe',
  'laari',
  "lab's",
  'labda',
  'label',
  'labia',
  'labis',
  'labor',
  'labra',
  "lac's",
  'laced',
  'lacer',
  'laces',
  'lacet',
  'lacey',
  'lacks',
  "lad's",
  'laded',
  'laden',
  'lader',
  'lades',
  'ladle',
  'laevo',
  'laffs',
  "lag's",
  'lagan',
  'lager',
  "lah's",
  'lahar',
  'laich',
  'laics',
  'laigh',
  'laika',
  'laiks',
  'laird',
  'lairs',
  'lairy',
  'laith',
  'laity',
  'laked',
  'laker',
  'lakes',
  'lakhs',
  'lakin',
  'laksa',
  'lalls',
  "lam's",
  'lamas',
  'lambs',
  'lamby',
  'lamed',
  'lamer',
  'lames',
  'lamia',
  'lammy',
  'lamps',
  'lanai',
  'lance',
  'lanch',
  'lande',
  'lands',
  'lanes',
  'lanky',
  'lants',
  "lap's",
  'lapel',
  'lapin',
  'lapis',
  'lapse',
  'larbo',
  'larch',
  'lards',
  'lardy',
  'laree',
  'lares',
  'large',
  'largo',
  'laris',
  'larks',
  'larky',
  'larns',
  'larum',
  'larva',
  'lased',
  'laser',
  'lases',
  'lassi',
  'lasso',
  'lassu',
  'lasts',
  "lat's",
  'latch',
  'lated',
  'laten',
  'later',
  'latex',
  'lathe',
  'lathi',
  'laths',
  'lathy',
  'latke',
  'latte',
  'lauan',
  'lauds',
  'laufs',
  'laugh',
  'laund',
  'laura',
  'laure',
  "lav's",
  'lavas',
  'laved',
  'laver',
  'laves',
  'lavra',
  "law's",
  'lawed',
  'lawin',
  'lawks',
  'lawns',
  'lawny',
  'laxer',
  'laxes',
  'laxly',
  "lay's",
  'layby',
  'layed',
  'layer',
  'layup',
  'lazar',
  'lazed',
  'lazes',
  'lazzi',
  'lazzo',
  "lea's",
  'leach',
  'leads',
  'leady',
  'leafs',
  'leafy',
  'leaks',
  'leaky',
  'leams',
  'leans',
  'leany',
  'leaps',
  'leapt',
  'learn',
  'lears',
  'leary',
  'lease',
  'leash',
  'least',
  'leats',
  'leave',
  'leavy',
  'leben',
  'lects',
  'ledge',
  'ledgy',
  'ledum',
  "lee's",
  'leech',
  'leeks',
  'leeps',
  'leers',
  'leery',
  'leese',
  'leets',
  'lefse',
  'lefte',
  'lefts',
  'lefty',
  "leg's",
  'legal',
  'leger',
  'leges',
  'legge',
  'leggy',
  'legit',
  'lehrs',
  'lehua',
  "lei's",
  'leirs',
  "lek's",
  'leman',
  'lemed',
  'lemel',
  'lemes',
  'lemma',
  'lemme',
  'lemon',
  'lemur',
  'lends',
  'lenes',
  'lenis',
  'lenos',
  'lense',
  'lenti',
  'lento',
  'leone',
  'leper',
  'lepid',
  'leppy',
  'lepra',
  'lepta',
  'lered',
  'leres',
  'lesbo',
  'leses',
  "let's",
  'lethe',
  'letup',
  "leu's",
  'leuch',
  'leuds',
  "lev's",
  'levee',
  'level',
  'lever',
  'levin',
  'levis',
  'lewis',
  'lexer',
  'lexes',
  'lexis',
  "ley's",
  'lezes',
  'lezzy',
  'liana',
  'liane',
  'liang',
  'liard',
  'liars',
  "lib's",
  'libel',
  'liber',
  'libra',
  'libri',
  'lichi',
  'licht',
  'licit',
  'licks',
  "lid's",
  'lidar',
  'lidos',
  "lie's",
  'liefs',
  'liege',
  'liens',
  'liers',
  'lieus',
  'lieve',
  'lifer',
  'lifts',
  'ligan',
  'liger',
  'light',
  'ligne',
  'liked',
  'liken',
  'liker',
  'likes',
  'likin',
  'lilac',
  'lills',
  'lilos',
  'lilts',
  'liman',
  'limas',
  'limax',
  'limba',
  'limbi',
  'limbo',
  'limbs',
  'limby',
  'limed',
  'limen',
  'limes',
  'limey',
  'limit',
  'limma',
  'limns',
  'limos',
  'limpa',
  'limps',
  'linac',
  'linch',
  'linds',
  'lindy',
  'lined',
  'linen',
  'liner',
  'lines',
  'liney',
  'linga',
  'lingo',
  'lings',
  'lingy',
  'linin',
  'links',
  'linky',
  'linns',
  'linos',
  'lints',
  'linty',
  'linum',
  'lions',
  "lip's",
  'lipid',
  'lipin',
  'lippy',
  'liras',
  'lirks',
  'lirot',
  'lisle',
  'lisps',
  "lit's",
  'litai',
  'litas',
  'liter',
  'lites',
  'lithe',
  'litho',
  'liths',
  'litre',
  'lived',
  'liven',
  'liver',
  'lives',
  'livid',
  'livor',
  'livre',
  'llama',
  'llano',
  'loach',
  'loads',
  'loafs',
  'loams',
  'loamy',
  'loans',
  'loath',
  'loave',
  "lob's",
  'lobar',
  'lobby',
  'lobed',
  'lobes',
  'lobos',
  'lobus',
  'local',
  'locks',
  'locos',
  'locum',
  'locus',
  'loden',
  'lodes',
  'lodge',
  'loess',
  'lofts',
  'lofty',
  "log's",
  'logan',
  'loges',
  'loggy',
  'logia',
  'logic',
  'logie',
  'login',
  'logoi',
  'logon',
  'logos',
  'loids',
  'loins',
  'loipe',
  'loirs',
  'lokes',
  'lolls',
  'lolly',
  'lolog',
  'lomas',
  'loner',
  'longa',
  'longe',
  'longs',
  "loo's",
  'looby',
  'looed',
  'looey',
  'loofa',
  'loofs',
  'looie',
  'looks',
  'looms',
  'loons',
  'loony',
  'loops',
  'loopy',
  'loord',
  'loose',
  'loots',
  "lop's",
  'loped',
  'loper',
  'lopes',
  'loppy',
  'loral',
  'loran',
  'lords',
  'lordy',
  'lorel',
  'lores',
  'loric',
  'loris',
  'lorry',
  'losel',
  'loser',
  'loses',
  'lossy',
  "lot's",
  'lotah',
  'lotas',
  'lotes',
  'lotic',
  'lotos',
  'lotte',
  'lotto',
  'lotus',
  'lough',
  'louie',
  'louis',
  'loupe',
  'loups',
  'loure',
  'lours',
  'loury',
  'louse',
  'lousy',
  'louts',
  'lovat',
  'loved',
  'lover',
  'loves',
  'lovey',
  "low's",
  'lowan',
  'lowed',
  'lower',
  'lowes',
  'lowly',
  'lownd',
  'lowns',
  'lowps',
  'lowse',
  "lox's",
  'loxed',
  'loxes',
  'loyal',
  'luaus',
  'lubed',
  'lubes',
  'lubra',
  'luces',
  'lucid',
  'lucks',
  'lucky',
  'lucre',
  'ludes',
  'ludic',
  'ludos',
  'luffa',
  'luffs',
  "lug's",
  'luged',
  'luger',
  'luges',
  'lulls',
  'lulus',
  'lumen',
  'lumma',
  'lumme',
  'lummy',
  'lumps',
  'lumpy',
  'lunar',
  'lunas',
  'lunch',
  'lunes',
  'lunet',
  'lunge',
  'lungi',
  'lungs',
  'lunks',
  'lunts',
  'lupin',
  'lupus',
  'lurch',
  'lured',
  'lurer',
  'lures',
  'lurex',
  'lurgy',
  'lurid',
  'lurks',
  'lurry',
  'lushy',
  'lusts',
  'lusty',
  'lusus',
  'lutea',
  'luted',
  'luter',
  'lutes',
  'luvvy',
  "lux's",
  'luxes',
  'lweis',
  'lxvii',
  'lyams',
  'lyard',
  'lyart',
  'lyase',
  'lycea',
  'lycee',
  'lycra',
  "lye's",
  'lying',
  'lymes',
  'lymph',
  'lynch',
  'lyres',
  'lyric',
  'lysed',
  'lyses',
  'lysin',
  'lysis',
  'lysol',
  'lyssa',
  'lythe',
  'lytic',
  'lytta',
  "ma'am",
  'maaed',
  'maars',
  'mabes',
  "mac's",
  'macaw',
  'maced',
  'macer',
  'maces',
  'mache',
  'macho',
  'machs',
  'macks',
  'macle',
  'macon',
  'macro',
  "mad's",
  'madam',
  'madge',
  'madid',
  'madly',
  'madre',
  'mafia',
  'mafic',
  "mag's",
  'mages',
  'maggs',
  'magic',
  'magma',
  'magot',
  'magus',
  'mahoe',
  'mahua',
  'mahwa',
  'maids',
  'maiko',
  'maiks',
  'maile',
  'maill',
  'mails',
  'maims',
  'mains',
  'maire',
  'mairs',
  'maise',
  'maist',
  'maize',
  'major',
  'makar',
  'maker',
  'makos',
  'malar',
  'malax',
  'males',
  'malic',
  'malik',
  'malis',
  'malls',
  'malms',
  'malmy',
  'malts',
  'malty',
  'malva',
  'mamas',
  'mamba',
  'mambo',
  'mamee',
  'mamey',
  'mamie',
  'mamma',
  'mammy',
  "man's",
  'manas',
  'manat',
  'maned',
  'maneh',
  'manes',
  'manet',
  'manga',
  'mange',
  'mango',
  'mangs',
  'mangy',
  'mania',
  'manic',
  'manky',
  'manly',
  'manna',
  'manor',
  'manos',
  'manse',
  'manta',
  'manto',
  'manty',
  'manuf',
  'manul',
  'manus',
  "map's",
  'maple',
  'maqui',
  'marae',
  'marah',
  'maras',
  'march',
  'marcs',
  'mardy',
  'mares',
  'marge',
  'margs',
  'maria',
  'marid',
  'marka',
  'marks',
  'marle',
  'marls',
  'marly',
  'marms',
  'maror',
  'marry',
  'marse',
  'marsh',
  'marts',
  'marvy',
  'masas',
  'mased',
  'maser',
  'mases',
  'mashy',
  'masks',
  'mason',
  'massa',
  'masse',
  'massy',
  'masts',
  'masty',
  'masus',
  "mat's",
  'matai',
  'match',
  'mated',
  'mater',
  'mates',
  'matey',
  'maths',
  'matin',
  'matlo',
  'matte',
  'matts',
  'matza',
  'matzo',
  'mauds',
  'mauls',
  'maund',
  'mauts',
  'mauve',
  'maven',
  'mavie',
  'mavin',
  'mavis',
  "maw's",
  'mawed',
  'mawks',
  'mawky',
  'mawrs',
  "max's",
  'maxed',
  'maxes',
  'maxim',
  'maxis',
  "may's",
  'mayan',
  'mayas',
  'maybe',
  'mayed',
  'mayor',
  'mayos',
  'mayst',
  'mazed',
  'mazer',
  'mazes',
  'mazut',
  'mbira',
  'meads',
  'meals',
  'mealy',
  'meane',
  'means',
  'meant',
  'meany',
  'mease',
  'meath',
  'meats',
  'meaty',
  'mebos',
  'mecca',
  'medal',
  'media',
  'medic',
  'medii',
  'medle',
  'meeds',
  'meers',
  'meets',
  "meg's",
  'meins',
  'meint',
  'meiny',
  'meith',
  'melds',
  'melee',
  'melic',
  'melik',
  'mells',
  'melon',
  'melts',
  'melty',
  "mem's",
  'memes',
  'memos',
  "men's",
  'menad',
  'mends',
  'mened',
  'menes',
  'menge',
  'mengs',
  'mensa',
  'mense',
  'mensh',
  'menta',
  'mento',
  'menus',
  'meous',
  'meows',
  'mercs',
  'mercy',
  'merde',
  'mered',
  'merel',
  'merer',
  'meres',
  'merge',
  'meril',
  'meris',
  'merit',
  'merks',
  'merle',
  'merls',
  'merry',
  'merse',
  'mesal',
  'mesas',
  'mesel',
  'meses',
  'meshy',
  'mesic',
  'mesne',
  'meson',
  'messy',
  'mesto',
  'metal',
  'meted',
  'meter',
  'metes',
  'metho',
  'meths',
  'metic',
  'metif',
  'metis',
  'metol',
  'metoo',
  'metre',
  'metro',
  'meuse',
  "mew's",
  'mewed',
  'mewer',
  'mewls',
  'mezes',
  'mezze',
  'mezzo',
  "mho's",
  'mhorr',
  'miaou',
  'miaow',
  'miasm',
  'miaul',
  'micas',
  'miche',
  'micks',
  'micky',
  'micos',
  'micra',
  'micro',
  "mid's",
  'middy',
  'midge',
  'midis',
  'midst',
  'miens',
  'miffs',
  'miffy',
  'miggs',
  'might',
  'miked',
  'mikes',
  'mikra',
  'mikva',
  'mikve',
  "mil's",
  'milch',
  'milds',
  'miler',
  'miles',
  'milfs',
  'milia',
  'milit',
  'milko',
  'milks',
  'milky',
  'mille',
  'mills',
  'milor',
  'milos',
  'milpa',
  'milts',
  'milty',
  'miltz',
  'mimed',
  'mimeo',
  'mimer',
  'mimes',
  'mimic',
  'mimsy',
  "min's",
  'minae',
  'minar',
  'minas',
  'mince',
  'mincy',
  'minds',
  'mined',
  'miner',
  'mines',
  'minge',
  'mings',
  'mingy',
  'minim',
  'minis',
  'minke',
  'minks',
  'minny',
  'minor',
  'minos',
  'mints',
  'minty',
  'minus',
  'mired',
  'mires',
  'mirex',
  'mirin',
  'mirks',
  'mirky',
  'mirth',
  'mirvs',
  'mirza',
  'misdo',
  'miser',
  'mises',
  'misgo',
  'misos',
  'missa',
  'missy',
  'mists',
  'misty',
  'mitch',
  'miter',
  'mites',
  'mitis',
  'mitre',
  'mitts',
  "mix's",
  'mixed',
  'mixen',
  'mixer',
  'mixes',
  'mixup',
  'mizen',
  'mneme',
  "moa's",
  'moans',
  'moats',
  "mob's",
  'mobby',
  'moble',
  'mocha',
  'mocks',
  "mod's",
  'modal',
  'model',
  'modem',
  'moder',
  'modes',
  'modii',
  'modus',
  'moggy',
  'mogul',
  'mohel',
  'mohrs',
  'mohur',
  'moils',
  'moira',
  'moire',
  'moist',
  'moits',
  'mojos',
  'mokes',
  'mokos',
  "mol's",
  'molal',
  'molar',
  'molas',
  'molds',
  'moldy',
  'moles',
  'molla',
  'molls',
  'molly',
  'molto',
  'molts',
  "mom's",
  'momes',
  'momma',
  'mommy',
  'momus',
  'monad',
  'monal',
  'monas',
  'monde',
  'mondo',
  'moner',
  'money',
  'mongo',
  'mongs',
  'monie',
  'monks',
  'monos',
  'monte',
  'month',
  "moo's",
  'mooch',
  'moods',
  'moody',
  'mooed',
  'mooks',
  'moola',
  'mooli',
  'mools',
  'moons',
  'moony',
  'moops',
  'moors',
  'moory',
  'moose',
  'moots',
  "mop's",
  'moped',
  'moper',
  'mopes',
  'mopey',
  'moppy',
  'mopsy',
  'mopus',
  'morae',
  'moral',
  'moras',
  'morat',
  'moray',
  'morel',
  'mores',
  'moria',
  'morne',
  'morns',
  'moron',
  'morph',
  'morra',
  'morro',
  'morse',
  'morts',
  'mosed',
  'moses',
  'mosey',
  'mosks',
  'mosso',
  'mossy',
  'moste',
  'mosts',
  "mot's",
  'moted',
  'motel',
  'motes',
  'motet',
  'motey',
  'moths',
  'mothy',
  'motif',
  'motor',
  'motte',
  'motto',
  'motts',
  'motty',
  'motza',
  'mouch',
  'moued',
  'moues',
  'mould',
  'mouls',
  'moult',
  'mound',
  'mount',
  'moups',
  'mourn',
  'mouse',
  'mousy',
  'mouth',
  'moved',
  'mover',
  'moves',
  'movie',
  "mow's",
  'mowas',
  'mowed',
  'mower',
  'mowra',
  'moxas',
  'moxie',
  'moyle',
  'moyls',
  'mozed',
  'mozes',
  'mozos',
  "mph's",
  'mpret',
  'mucho',
  'mucic',
  'mucid',
  'mucin',
  'mucks',
  'mucky',
  'mucor',
  'mucro',
  'mucus',
  "mud's",
  'muddy',
  'mudge',
  'mudir',
  'mudra',
  'muffs',
  'mufti',
  "mug's",
  'muggs',
  'muggy',
  'muhly',
  'muids',
  'muirs',
  'muist',
  'mujik',
  'mulch',
  'mulct',
  'muled',
  'mules',
  'muley',
  'mulga',
  'mulla',
  'mulls',
  'mulse',
  'mulsh',
  'multi',
  "mum's",
  'mumms',
  'mummy',
  'mumps',
  'mumsy',
  'mumus',
  'munch',
  'mungo',
  'mungs',
  'munis',
  'munts',
  'muntu',
  'muons',
  'mural',
  'muras',
  'mured',
  'mures',
  'murex',
  'murid',
  'murks',
  'murky',
  'murly',
  'murra',
  'murre',
  'murrs',
  'murry',
  'murva',
  'musca',
  'mused',
  'muser',
  'muses',
  'muset',
  'musha',
  'mushy',
  'music',
  'musit',
  'musks',
  'musky',
  'musos',
  'mussy',
  'musth',
  'musts',
  'musty',
  "mut's",
  'mutch',
  'muted',
  'muter',
  'mutes',
  'muton',
  'mutts',
  'muxed',
  'muxes',
  'muzak',
  'muzzy',
  'mvule',
  'myall',
  'mycol',
  'mylar',
  'mynah',
  'mynas',
  'myoid',
  'myoma',
  'myope',
  'myops',
  'myopy',
  'myrrh',
  'mysid',
  'myths',
  'mythy',
  'mzees',
  'naams',
  'naans',
  'nabes',
  'nabis',
  'nabks',
  'nabla',
  'nabob',
  'nache',
  'nacho',
  'nacre',
  'nadas',
  'nadir',
  'naeve',
  'naevi',
  'naffs',
  "nag's",
  'nagas',
  'naggy',
  'nagor',
  'nahal',
  'naiad',
  'naifs',
  'naiks',
  'nails',
  'naira',
  'nairu',
  'naive',
  'naked',
  'naker',
  'nakfa',
  'nalas',
  'naled',
  'nalla',
  'named',
  'namer',
  'names',
  'nanas',
  'nance',
  'nancy',
  'nandu',
  'nanna',
  'nanny',
  "nap's",
  'napas',
  'napes',
  'napoo',
  'nappa',
  'nappe',
  'nappy',
  'naras',
  'narco',
  'narcs',
  'nards',
  'nares',
  'naric',
  'naris',
  'narks',
  'narky',
  'narre',
  'nasal',
  'nasty',
  'natal',
  'natch',
  'nates',
  'natty',
  'naunt',
  'naval',
  'navar',
  'navel',
  'naves',
  'navew',
  'navig',
  'navvy',
  'nawab',
  "nay's",
  'nazes',
  'nazir',
  'nazis',
  "ne'er",
  'neafe',
  'neals',
  'neaps',
  'nears',
  'neath',
  'neats',
  "neb's",
  'nebek',
  'nebel',
  'necks',
  'neddy',
  'needs',
  'needy',
  'neeld',
  'neele',
  'neemb',
  'neems',
  'neeps',
  'neese',
  'neeze',
  'negro',
  'negus',
  'neifs',
  'neigh',
  'neist',
  'neive',
  'nelis',
  'nelly',
  'nemas',
  'nenes',
  'neons',
  'neper',
  'nepit',
  'neral',
  'nerds',
  'nerdy',
  'nerka',
  'nerks',
  'nerol',
  'nerts',
  'nertz',
  'nerve',
  'nervy',
  'nests',
  "net's",
  'netes',
  'netop',
  'netts',
  'netty',
  'neuks',
  'neume',
  'neums',
  'nevel',
  'never',
  'neves',
  'nevus',
  "new's",
  'newed',
  'newel',
  'newer',
  'newie',
  'newly',
  'newsy',
  'newts',
  'nexts',
  'nexus',
  'ngaio',
  'ngana',
  'ngwee',
  "nib's",
  'nicad',
  'nicer',
  'niche',
  'nicht',
  'nicks',
  'nicol',
  'nidal',
  'nided',
  'nides',
  'nidor',
  'nidus',
  'niece',
  'niefs',
  'nieve',
  'niffs',
  'niffy',
  'nifty',
  'nigga',
  'nighs',
  'night',
  'nihil',
  'nikau',
  "nil's",
  'nills',
  'nimbi',
  'nimby',
  'nines',
  'ninja',
  'ninny',
  'ninon',
  'ninth',
  "nip's",
  'nipas',
  'nippy',
  'nirls',
  'nirly',
  'nisei',
  'nisse',
  'nisus',
  "nit's",
  'niter',
  'nites',
  'nitid',
  'niton',
  'nitre',
  'nitro',
  'nitry',
  'nitty',
  'nival',
  "nix's",
  'nixed',
  'nixes',
  'nixie',
  'nizam',
  "nob's",
  'nobby',
  'noble',
  'nobly',
  'nocks',
  "nod's",
  'nodal',
  'noddy',
  'nodes',
  'nodus',
  'noels',
  "nog's",
  'noggs',
  'nohow',
  'noils',
  'noily',
  'noint',
  'noirs',
  'noise',
  'noisy',
  'nolls',
  'nolos',
  'nomad',
  'nomas',
  'nomen',
  'nomes',
  'nomic',
  'nomoi',
  'nomos',
  'nonas',
  'nonce',
  'nones',
  'nonet',
  'nongs',
  'nonny',
  'nonyl',
  'nooks',
  'nooky',
  'noons',
  'noops',
  'noose',
  'nopal',
  'nopes',
  'noria',
  'noris',
  'norks',
  'norms',
  'north',
  'nosed',
  'noser',
  'noses',
  'nosey',
  'notal',
  'notch',
  'noted',
  'noter',
  'notes',
  'notre',
  'notum',
  'nould',
  'noule',
  'nouns',
  'nouny',
  'noups',
  'novae',
  'novas',
  'novel',
  'novum',
  "now's",
  'noway',
  'nowed',
  'nowel',
  'nowts',
  'noxal',
  'noyau',
  'noyes',
  "nub's",
  'nubby',
  'nubia',
  'nucha',
  'nuder',
  'nudes',
  'nudge',
  'nudie',
  'nudzh',
  'nugae',
  'nuked',
  'nukes',
  'nulla',
  'nulls',
  'numbs',
  'numen',
  'numis',
  "nun's",
  'nurds',
  'nurls',
  'nurrs',
  'nurse',
  "nut's",
  'nutsy',
  'nutty',
  'nyaff',
  'nyala',
  'nylon',
  'nymph',
  "oaf's",
  "oak's",
  'oaken',
  'oakum',
  "oar's",
  'oared',
  'oases',
  'oasis',
  'oasts',
  "oat's",
  'oaten',
  'oater',
  'oaths',
  'oaves',
  'obang',
  'obeah',
  'obeli',
  'obese',
  'obeys',
  "obi's",
  'obias',
  'obied',
  'obiit',
  'obits',
  'objet',
  'oboes',
  'obole',
  'oboli',
  'obols',
  'obruk',
  "oca's",
  'occas',
  'occur',
  'ocean',
  'ocher',
  'ochre',
  'ochry',
  'ocker',
  'ocrea',
  'octad',
  'octal',
  'octan',
  'octas',
  'octet',
  'octyl',
  'oculi',
  'odahs',
  'odals',
  "odd's",
  'odder',
  'oddly',
  "ode's",
  'odeon',
  'odeum',
  'odism',
  'odist',
  'odium',
  'odors',
  'odour',
  'odsos',
  'odyle',
  'odyls',
  'oecus',
  'ofays',
  "off's",
  'offal',
  'offed',
  'offer',
  'oflag',
  'often',
  'ofter',
  'ogams',
  'ogeed',
  'ogees',
  'oggin',
  'ogham',
  'ogive',
  'ogled',
  'ogler',
  'ogles',
  'ogmic',
  'ogres',
  'ohias',
  'ohing',
  "ohm's",
  'ohmic',
  'ohone',
  'oidia',
  "oil's",
  'oiled',
  'oiler',
  'oinks',
  'oints',
  'ojime',
  "oka's",
  'okapi',
  'okays',
  'okehs',
  'okras',
  'oktas',
  "old's",
  'olden',
  'older',
  'oldie',
  "ole's",
  'oleic',
  'olein',
  'olent',
  'oleos',
  'oleum',
  'olios',
  'olive',
  'ollas',
  'ollav',
  "olm's",
  'ology',
  'olpae',
  'olpes',
  'omasa',
  'omber',
  'ombre',
  'ombus',
  'omega',
  'omens',
  'omers',
  'omits',
  'omlah',
  'omrah',
  'oncer',
  'onces',
  'oncus',
  "one's",
  'oners',
  'onery',
  'onion',
  'onium',
  'onkus',
  'onlay',
  'onned',
  'onset',
  'ontic',
  'oobit',
  'oohed',
  'oomph',
  'oonts',
  'oorie',
  'ooses',
  'ootid',
  'oozed',
  'oozes',
  'opahs',
  'opals',
  'opens',
  'opepe',
  'opera',
  'opine',
  'oping',
  'opium',
  'oppos',
  'opsin',
  'opted',
  'opter',
  'optic',
  'orach',
  'oracy',
  'orals',
  'orang',
  'orant',
  'orate',
  "orb's",
  'orbed',
  'orbit',
  "orc's",
  'orcas',
  'orcin',
  'ordos',
  "ore's",
  'oread',
  'orfes',
  'organ',
  'orgia',
  'orgic',
  'orgue',
  'oribi',
  'oriel',
  'orles',
  'orlon',
  'orlop',
  'ormer',
  'ornis',
  'orpin',
  'orris',
  'ortho',
  'orzos',
  'oshac',
  'osier',
  'osmic',
  'osmol',
  'ossia',
  'ostia',
  'otary',
  'ottar',
  'otter',
  'ottos',
  'oubit',
  'ought',
  'ouija',
  'ounce',
  'ouphe',
  'ouphs',
  'ourie',
  'ousel',
  'ousts',
  "out's",
  'outby',
  'outdo',
  'outed',
  'outer',
  'outgo',
  'outre',
  'outta',
  'ouzel',
  'ouzos',
  "ova's",
  'ovals',
  'ovary',
  'ovate',
  'ovens',
  'overs',
  'overt',
  'ovine',
  'ovist',
  'ovoid',
  'ovoli',
  'ovolo',
  'ovule',
  'owari',
  'owche',
  'owing',
  "owl's",
  'owled',
  'owler',
  'owlet',
  'owned',
  'owner',
  'owsen',
  'oxbow',
  'oxers',
  'oxeye',
  'oxide',
  'oxids',
  'oxime',
  'oxims',
  'oxlip',
  'oxter',
  'oyers',
  'ozeki',
  'ozena',
  'ozone',
  'pacas',
  'paced',
  'pacer',
  'paces',
  'pacey',
  'pacha',
  'packs',
  'pacos',
  'pacts',
  "pad's",
  'padas',
  'paddy',
  'padis',
  'padle',
  'padma',
  'padre',
  'padri',
  'paean',
  'paeon',
  'pagan',
  'paged',
  'pager',
  'pages',
  'pagod',
  'pagri',
  'paiks',
  'pails',
  'pains',
  'paint',
  'pairs',
  'paisa',
  'paise',
  'pakka',
  "pal's",
  'palas',
  'palay',
  'palea',
  'paled',
  'paleo',
  'paler',
  'pales',
  'palet',
  'palki',
  'palla',
  'palls',
  'pally',
  'palms',
  'palmy',
  'palpi',
  'palps',
  'palsy',
  'pampa',
  "pan's",
  'panax',
  'panda',
  'pands',
  'pandy',
  'paned',
  'panel',
  'panes',
  'panga',
  'pangs',
  'panic',
  'panim',
  'panne',
  'pansy',
  'panto',
  'pants',
  'panty',
  'paoli',
  'paolo',
  "pap's",
  'papal',
  'papas',
  'papaw',
  'paper',
  'papes',
  'pappi',
  'pappy',
  "par's",
  'parae',
  'paras',
  'parch',
  'pardi',
  'pards',
  'pardy',
  'pared',
  'pareo',
  'parer',
  'pares',
  'pareu',
  'parev',
  'parge',
  'pargo',
  'paris',
  'parka',
  'parki',
  'parks',
  'parky',
  'parle',
  'parly',
  'parol',
  'parps',
  'parrs',
  'parry',
  'parse',
  'parti',
  'parts',
  'party',
  'parve',
  'parvo',
  'paseo',
  'pases',
  'pasha',
  'pashm',
  'paspy',
  'passe',
  'pasta',
  'paste',
  'pasts',
  'pasty',
  "pat's",
  'patas',
  'patch',
  'pated',
  'paten',
  'pates',
  'paths',
  'patin',
  'patio',
  'patly',
  'patsy',
  'patte',
  'patty',
  'pauas',
  'pauls',
  'pause',
  'pavan',
  'paved',
  'paven',
  'paver',
  'paves',
  'pavid',
  'pavin',
  'pavis',
  "paw's",
  'pawas',
  'pawaw',
  'pawed',
  'pawer',
  'pawks',
  'pawky',
  'pawls',
  'pawns',
  "pax's",
  'paxes',
  "pay's",
  'payed',
  'payee',
  'payer',
  'payor',
  "pct's",
  "pea's",
  'peace',
  'peach',
  'peage',
  'peags',
  'peaks',
  'peaky',
  'peals',
  'peans',
  'peare',
  'pearl',
  'pears',
  'peart',
  'pease',
  'peats',
  'peaty',
  'peavy',
  'peaze',
  'pebas',
  'pecan',
  'pechs',
  'pecks',
  'pecky',
  'pedal',
  'pedes',
  'pedro',
  "pee's",
  'peeks',
  'peels',
  'peens',
  'peeoy',
  'peeps',
  'peers',
  'peery',
  'peeve',
  "peg's",
  'peggy',
  'peghs',
  'peins',
  'peise',
  'peize',
  'pekan',
  'pekes',
  'pekin',
  'pekoe',
  'peles',
  'pelfs',
  'pelma',
  'pelon',
  'pelta',
  'pelts',
  "pen's",
  'penal',
  'pence',
  'pends',
  'pened',
  'penes',
  'pengo',
  'penie',
  'penis',
  'penks',
  'penna',
  'penne',
  'penni',
  'penny',
  'pents',
  'peons',
  'peony',
  "pep's",
  'pepla',
  'pepos',
  'peppy',
  'perai',
  'perch',
  'perdu',
  'perdy',
  'perea',
  'peres',
  'peril',
  'peris',
  'perks',
  'perky',
  'perms',
  'perns',
  'perps',
  'perry',
  'perse',
  'perst',
  'perts',
  'perve',
  'pervs',
  'pesky',
  'pesos',
  'pesto',
  'pests',
  'pesty',
  "pet's",
  'petal',
  'peter',
  'petit',
  'petre',
  'petro',
  'petti',
  'petto',
  'petty',
  "pew's",
  'pewee',
  'pewit',
  'peyse',
  'phage',
  'phare',
  'phase',
  'pheer',
  'phene',
  'pheon',
  'phews',
  "phi's",
  'phial',
  'phish',
  'phlox',
  'phoca',
  'phohs',
  'phone',
  'phono',
  'phons',
  'phony',
  'photo',
  'phots',
  'phpht',
  'phren',
  'phuts',
  'phyla',
  'phyle',
  "pia's",
  'piano',
  'pians',
  'pibal',
  "pic's",
  'pical',
  'picas',
  'piccy',
  'picks',
  'picky',
  'picot',
  'picra',
  'picul',
  "pie's",
  'piece',
  'piend',
  'piers',
  'pieta',
  'piets',
  'piety',
  'piezo',
  "pig's",
  'piggy',
  'pight',
  'pigmy',
  'piing',
  'pikas',
  'piked',
  'piker',
  'pikes',
  'pikis',
  'pikul',
  'pilaf',
  'pilar',
  'pilau',
  'pilaw',
  'pilch',
  'pilea',
  'piled',
  'pilei',
  'piler',
  'piles',
  'pilis',
  'pills',
  'pilot',
  'pilow',
  'pilum',
  'pilus',
  'pimas',
  'pimps',
  "pin's",
  'pinas',
  'pinch',
  'pined',
  'pines',
  'piney',
  'pingo',
  'pings',
  'pinko',
  'pinks',
  'pinky',
  'pinna',
  'pinny',
  'pinon',
  'pinot',
  'pinta',
  'pinto',
  'pints',
  'pinup',
  'pions',
  'pious',
  'pioye',
  'pioys',
  "pip's",
  'pipal',
  'pipas',
  'piped',
  'piper',
  'pipes',
  'pipet',
  'pipis',
  'pipit',
  'pippy',
  'pipul',
  'pique',
  'pirai',
  'pirls',
  'pirns',
  'pirog',
  'pisco',
  'pises',
  'pisky',
  'pisos',
  'piste',
  "pit's",
  'pitas',
  'pitch',
  'piths',
  'pithy',
  'piton',
  'pitta',
  'piums',
  'pivot',
  "pix's",
  'pixed',
  'pixel',
  'pixes',
  'pixie',
  'pizes',
  'pizza',
  'place',
  'plack',
  'plage',
  'plaid',
  'plain',
  'plait',
  'plane',
  'plank',
  'plano',
  'plans',
  'plant',
  'plaps',
  'plash',
  'plasm',
  'plast',
  'plate',
  'plats',
  'platy',
  'playa',
  'plays',
  'plaza',
  'plead',
  'pleas',
  'pleat',
  'plebe',
  'plebs',
  'plena',
  'pleon',
  'plesh',
  'plews',
  'plica',
  'plied',
  'plier',
  'plies',
  'plims',
  'pling',
  'plink',
  'ploat',
  'ploce',
  'plods',
  'plonk',
  'plook',
  'plops',
  'plots',
  'plotz',
  'plouk',
  'plows',
  'ploys',
  'pluck',
  'pluff',
  'plugs',
  'plumb',
  'plume',
  'plump',
  'plums',
  'plumy',
  'plunk',
  'plush',
  "ply's",
  'plyer',
  'poach',
  'poaka',
  'poboy',
  'pocks',
  'pocky',
  "pod's",
  'podal',
  'poddy',
  'podex',
  'podge',
  'podgy',
  'podia',
  'poems',
  'poesy',
  'poets',
  'pogey',
  'pogge',
  'pogos',
  "poi's",
  'poils',
  'poilu',
  'poind',
  'point',
  'poise',
  'pokal',
  'poked',
  'poker',
  'pokes',
  'pokey',
  "pol's",
  'polar',
  'poled',
  'poler',
  'poles',
  'poley',
  'polio',
  'polis',
  'polit',
  'polka',
  'polks',
  'polls',
  'polly',
  'polos',
  'polts',
  'polyp',
  'polys',
  "pom's",
  'pombe',
  'pomes',
  'pommy',
  'pomos',
  'pomps',
  'ponce',
  'poncy',
  'ponds',
  'pones',
  'poney',
  'ponga',
  'pongo',
  'pongs',
  'pongy',
  'ponts',
  'ponty',
  'pooch',
  'poods',
  'pooed',
  'poofs',
  'poofy',
  'poohs',
  'pooja',
  'pooka',
  'pooks',
  'pools',
  'poons',
  'poops',
  'poori',
  'poort',
  'poots',
  'poove',
  'poovy',
  "pop's",
  'popes',
  'poppa',
  'poppy',
  'popsy',
  'popup',
  'poral',
  'porch',
  'pored',
  'porer',
  'pores',
  'porge',
  'porgy',
  'porks',
  'porky',
  'porno',
  'porns',
  'porny',
  'porta',
  'porte',
  'ports',
  'porty',
  'posed',
  'poser',
  'poses',
  'posey',
  'posit',
  'posse',
  'posts',
  "pot's",
  'potch',
  'poted',
  'potes',
  'potin',
  'potoo',
  'potsy',
  'potto',
  'potts',
  'potty',
  'pouch',
  'pouff',
  'poufs',
  'pouke',
  'pouks',
  'poule',
  'poulp',
  'poult',
  'pound',
  'pours',
  'pouts',
  'pouty',
  'powan',
  'power',
  "pox's",
  'poxed',
  'poxes',
  'poyou',
  'pozzy',
  'praam',
  'prads',
  'prahu',
  'prams',
  'prana',
  'prang',
  'prank',
  'praos',
  'prase',
  'prate',
  'prats',
  'pratt',
  'praty',
  'praus',
  'prawn',
  'prays',
  'predy',
  'preed',
  'preen',
  'prees',
  'preif',
  'premy',
  'prent',
  'preop',
  'preps',
  'presa',
  'prese',
  'press',
  'prest',
  'preve',
  'prexy',
  'preys',
  'prial',
  'price',
  'prick',
  'pricy',
  'pride',
  'pried',
  'prier',
  'pries',
  'prigs',
  'prill',
  'prima',
  'prime',
  'primi',
  'primo',
  'primp',
  'prims',
  'primy',
  'prink',
  'print',
  'prion',
  'prior',
  'prise',
  'prism',
  'priss',
  'privy',
  'prize',
  "pro's",
  'proas',
  'probe',
  'probs',
  'prods',
  'proem',
  'profs',
  'progs',
  'proke',
  'prole',
  'promo',
  'proms',
  'prone',
  'prong',
  'pronk',
  'proof',
  'proos',
  'propr',
  'props',
  'prore',
  'prose',
  'proso',
  'pross',
  'prost',
  'prosy',
  'proto',
  'proud',
  'prove',
  'provo',
  'prowl',
  'prows',
  'proxy',
  'prude',
  'pruhs',
  'prune',
  'prunt',
  'pruta',
  "pry's",
  'pryer',
  'pryse',
  'psalm',
  'pseud',
  'pshaw',
  "psi's",
  'psion',
  'psoae',
  'psoai',
  'psoas',
  'psora',
  'pssts',
  'psych',
  'psyop',
  "pub's",
  'pubes',
  'pubic',
  'pubis',
  'puces',
  'pucka',
  'pucks',
  "pud's",
  'puddy',
  'pudge',
  'pudgy',
  'pudic',
  'pudsy',
  'pudus',
  'puers',
  'puffs',
  'puffy',
  "pug's",
  'puggy',
  'pughs',
  'pugil',
  'pujah',
  'pujas',
  'puked',
  'puker',
  'pukes',
  'pukka',
  "pul's",
  'pulas',
  'puled',
  'puler',
  'pules',
  'pulik',
  'pulis',
  'pulka',
  'pulks',
  'pulls',
  'pulmo',
  'pulps',
  'pulpy',
  'pulse',
  'pumas',
  'pumps',
  "pun's",
  'punas',
  'punce',
  'punch',
  'punga',
  'pungs',
  'pungy',
  'punji',
  'punka',
  'punks',
  'punky',
  'punny',
  'punto',
  'punts',
  'punty',
  "pup's",
  'pupae',
  'pupal',
  'pupas',
  'pupil',
  'puppy',
  'purda',
  'pured',
  'puree',
  'purer',
  'pures',
  'purge',
  'purim',
  'purin',
  'puris',
  'purls',
  'purrs',
  'purse',
  'pursy',
  'purty',
  "pus's",
  'puses',
  'pushy',
  'pussy',
  "put's",
  'putid',
  'puton',
  'putti',
  'putto',
  'putts',
  'putty',
  'pwned',
  "pya's",
  'pyats',
  'pyets',
  'pygal',
  'pygmy',
  'pyins',
  'pylon',
  'pyned',
  'pynes',
  'pyoid',
  'pyots',
  'pyral',
  'pyran',
  'pyres',
  'pyrex',
  'pyric',
  "pyx's",
  'pyxed',
  'pyxes',
  'pyxie',
  'pyxis',
  'pzazz',
  'qadis',
  'qaids',
  'qanat',
  'qepiq',
  'qibla',
  'qophs',
  'quack',
  'quads',
  'quaff',
  'quags',
  'quail',
  'quair',
  'quais',
  'quake',
  'quaky',
  'quale',
  'qualm',
  'quant',
  'quare',
  'quark',
  'quart',
  'quash',
  'quasi',
  'quass',
  'quate',
  'quats',
  'quays',
  'qubit',
  'quean',
  'queen',
  'queer',
  'quell',
  'queme',
  'quena',
  'quern',
  'query',
  'quest',
  'queue',
  'queys',
  'quick',
  'quids',
  'quiet',
  'quiff',
  'quill',
  'quilt',
  'quims',
  'quina',
  'quine',
  'quins',
  'quint',
  'quipo',
  'quips',
  'quipu',
  'quire',
  'quirk',
  'quirt',
  'quist',
  'quite',
  'quits',
  'quoad',
  'quods',
  'quoif',
  'quoin',
  'quoit',
  'quoll',
  'quonk',
  'quops',
  'quota',
  'quote',
  'quoth',
  'qursh',
  'rabat',
  'rabbi',
  'rabic',
  'rabid',
  'rabis',
  'raced',
  'racer',
  'races',
  'rache',
  'racks',
  'racon',
  "rad's",
  'radar',
  'radii',
  'radio',
  'radix',
  'radon',
  'raffs',
  'rafts',
  "rag's",
  'ragas',
  'raged',
  'ragee',
  'rager',
  'rages',
  'ragga',
  'raggs',
  'raggy',
  'ragis',
  'rahed',
  'raias',
  'raids',
  'raile',
  'rails',
  'rains',
  'rainy',
  'raise',
  'raita',
  'raits',
  "raj's",
  'rajah',
  'rajas',
  'rajes',
  'raked',
  'rakee',
  'raker',
  'rakes',
  'rakis',
  'rakus',
  'rales',
  'rally',
  'ralph',
  "ram's",
  'ramal',
  'ramee',
  'ramen',
  'ramet',
  'ramie',
  'ramin',
  'ramis',
  'rammy',
  'ramps',
  'ramus',
  'ranas',
  'rance',
  'ranch',
  'rands',
  'randy',
  'ranee',
  'range',
  'rangy',
  'ranid',
  'ranis',
  'ranks',
  'rants',
  "rap's",
  'raped',
  'raper',
  'rapes',
  'raphe',
  'rapid',
  'rared',
  'rarer',
  'rares',
  'rased',
  'raser',
  'rases',
  'rasps',
  'raspy',
  'rasse',
  "rat's",
  'ratal',
  'ratan',
  'ratas',
  'ratch',
  'rated',
  'ratel',
  'rater',
  'rates',
  'rathe',
  'raths',
  'ratio',
  'ratoo',
  'ratos',
  'ratty',
  'ratus',
  'rauns',
  'raved',
  'ravel',
  'raven',
  'raver',
  'raves',
  'ravin',
  "raw's",
  'rawer',
  'rawin',
  'rawly',
  'rawns',
  'raxed',
  'raxes',
  "ray's",
  'rayah',
  'rayas',
  'rayed',
  'rayle',
  'rayon',
  'razed',
  'razee',
  'razer',
  'razes',
  'razoo',
  'razor',
  "rbi's",
  'reach',
  'react',
  'readd',
  'reads',
  'ready',
  'reais',
  'reaks',
  'realm',
  'realo',
  'reals',
  'reams',
  'reamy',
  'reans',
  'reaps',
  'rearm',
  'rears',
  'reast',
  'reata',
  'reate',
  'reave',
  'rebar',
  'rebbe',
  'rebec',
  'rebel',
  'rebia',
  'rebid',
  'rebit',
  'rebop',
  'rebus',
  'rebut',
  'rebuy',
  "rec'd",
  "rec's",
  'recap',
  'recce',
  'recco',
  'reccy',
  'recit',
  'recks',
  'recon',
  'recta',
  'recti',
  'recto',
  'recur',
  'recut',
  "red's",
  'redan',
  'redds',
  'reddy',
  'reded',
  'redes',
  'redia',
  'redid',
  'redip',
  'redly',
  'redon',
  'redos',
  'redox',
  'redry',
  'redub',
  'redux',
  'redye',
  'reech',
  'reeds',
  'reedy',
  'reefs',
  'reefy',
  'reeks',
  'reeky',
  'reels',
  'reens',
  'reest',
  'reeve',
  "ref's",
  'refed',
  'refel',
  'refer',
  'reffo',
  'refit',
  'refix',
  'refly',
  'refry',
  'regal',
  'regar',
  'reges',
  'regex',
  'reggo',
  'regie',
  'regma',
  'regna',
  'regur',
  'rehab',
  'rehem',
  'reifs',
  'reify',
  'reign',
  'reiki',
  'reink',
  'reins',
  'reist',
  'reive',
  'rejig',
  'rejon',
  'rekey',
  'relax',
  'relay',
  'relet',
  'relic',
  'relit',
  "rem's",
  'reman',
  'remap',
  'remen',
  'remet',
  'remex',
  'remit',
  'remix',
  'renal',
  'renay',
  'rends',
  'renes',
  'renew',
  'renga',
  'renig',
  'renin',
  'renne',
  'rente',
  'rents',
  'reoil',
  'reorg',
  "rep's",
  'repay',
  'repeg',
  'repel',
  'repin',
  'repla',
  'reply',
  'repos',
  'repot',
  'repps',
  'repro',
  'reran',
  'rerig',
  'rerun',
  'resat',
  'resaw',
  'resay',
  'resee',
  'reses',
  'reset',
  'resew',
  'resid',
  'resin',
  'resit',
  'resod',
  'resow',
  'rests',
  'resty',
  'retag',
  'retax',
  'retch',
  'retem',
  'retes',
  'retia',
  'retie',
  'retro',
  'retry',
  'reuse',
  "rev's",
  'revel',
  'revet',
  'revie',
  'revue',
  'rewan',
  'rewax',
  'rewed',
  'rewet',
  'rewin',
  'rewon',
  'rexes',
  'rheas',
  'rheme',
  'rheum',
  'rhine',
  'rhino',
  "rho's",
  'rhody',
  'rhomb',
  'rhone',
  'rhumb',
  'rhyme',
  'rhyta',
  'rials',
  'riant',
  'riata',
  "rib's",
  'ribby',
  'ribes',
  'riced',
  'ricer',
  'rices',
  'ricey',
  'richt',
  'ricin',
  'ricks',
  'rider',
  'rides',
  'ridge',
  'ridgy',
  'riels',
  'riems',
  'rieve',
  'rifer',
  'riffs',
  'rifle',
  'rifts',
  'rifty',
  "rig's",
  'riggs',
  'right',
  'rigid',
  'rigol',
  'rigor',
  'riled',
  'riles',
  'riley',
  'rille',
  'rills',
  "rim's",
  'rimae',
  'rimed',
  'rimer',
  'rimes',
  'rimus',
  'rinds',
  'rindy',
  'rings',
  'rinks',
  'rinse',
  'rioja',
  'riots',
  "rip's",
  'riped',
  'ripen',
  'riper',
  'ripes',
  'risen',
  'riser',
  'rises',
  'rishi',
  'risks',
  'risky',
  'risps',
  'risus',
  'rites',
  'ritts',
  'ritzy',
  'rival',
  'rivas',
  'rived',
  'rivel',
  'riven',
  'river',
  'rives',
  'rivet',
  'rivos',
  'riyal',
  'rizas',
  'roach',
  'roads',
  'roady',
  'roams',
  'roans',
  'roars',
  'roary',
  'roast',
  'robed',
  'rober',
  'robes',
  'robin',
  'roble',
  'robot',
  "roc's",
  'rocks',
  'rocky',
  "rod's",
  'roded',
  'rodeo',
  'rodes',
  "roe's",
  'roger',
  'rogue',
  'roguy',
  'roils',
  'roily',
  'roist',
  'roked',
  'roker',
  'rokes',
  'rolag',
  'roles',
  'rolfs',
  'rolls',
  'romal',
  'roman',
  'romas',
  'romeo',
  'romps',
  'ronde',
  'rondo',
  'roneo',
  'rones',
  'ronin',
  'roods',
  'rooed',
  'roofs',
  'roofy',
  'rooks',
  'rooky',
  'rooms',
  'roomy',
  'roons',
  'roops',
  'roopy',
  'roosa',
  'roose',
  'roost',
  'roots',
  'rooty',
  'roped',
  'roper',
  'ropes',
  'ropey',
  'roque',
  'roral',
  'rores',
  'roric',
  'rorid',
  'rorie',
  'rorts',
  'rorty',
  'rosed',
  'roses',
  'roset',
  'roshi',
  'rosin',
  'rosti',
  "rot's",
  'rotal',
  'rotas',
  'rotch',
  'roted',
  'rotes',
  'rotis',
  'rotls',
  'rotor',
  'rotos',
  'rotte',
  'rouen',
  'roues',
  'rouge',
  'rough',
  'round',
  'roups',
  'roupy',
  'rouse',
  'roust',
  'route',
  'routh',
  'routs',
  'roved',
  'roven',
  'rover',
  'roves',
  "row's",
  'rowan',
  'rowdy',
  'rowed',
  'rowel',
  'rowen',
  'rower',
  'rowth',
  'royal',
  'royst',
  "rpm's",
  'ruana',
  "rub's",
  'rubai',
  'rubby',
  'rubel',
  'rubes',
  'ruble',
  'rubus',
  'ruche',
  'rucks',
  'rudas',
  'rudds',
  'ruddy',
  'ruder',
  'rudie',
  "rue's",
  'ruers',
  'ruffe',
  'ruffs',
  "rug's",
  'rugae',
  'rugal',
  'rugby',
  'ruggy',
  'ruing',
  'ruins',
  'rukhs',
  'ruled',
  'ruler',
  'rules',
  "rum's",
  'rumal',
  'rumba',
  'rumbo',
  'rumen',
  'rumly',
  'rummy',
  'rumor',
  'rumps',
  'rumpy',
  "run's",
  'runch',
  'runds',
  'runed',
  'runes',
  'rungs',
  'runic',
  'runny',
  'runts',
  'runty',
  'runup',
  'runza',
  'rupee',
  'rupia',
  'rural',
  'rurps',
  'rurus',
  'ruses',
  'rushy',
  'rusks',
  'rusma',
  'rusts',
  'rusty',
  "rut's",
  'ruths',
  'rutin',
  'rutty',
  "rya's",
  'ryals',
  'rybat',
  "rye's",
  'ryked',
  'rykes',
  'rynds',
  'ryots',
  'ryper',
  'sabal',
  'sabed',
  'saber',
  'sabes',
  'sabin',
  'sabir',
  'sabji',
  'sable',
  'sabot',
  'sabra',
  'sabre',
  "sac's",
  'sacks',
  'sacra',
  'sades',
  'sadhe',
  'sadhu',
  'sadis',
  'sadly',
  'sadza',
  'saeta',
  'safer',
  'safes',
  "sag's",
  'sagas',
  'sager',
  'sages',
  'saggy',
  'sagos',
  'sagum',
  'sahib',
  'saice',
  'saick',
  'saics',
  'saids',
  'saiga',
  'sails',
  'saily',
  'saims',
  'sains',
  'saint',
  'sairs',
  'saist',
  'saith',
  'sajou',
  'sakai',
  'saker',
  'sakes',
  'sakia',
  'sakis',
  'salad',
  'salal',
  'salep',
  'sales',
  'salet',
  'salic',
  'salix',
  'salle',
  'sally',
  'salmi',
  'salol',
  'salon',
  'salop',
  'salpa',
  'salps',
  'salsa',
  'salse',
  'salto',
  'salts',
  'salty',
  'salue',
  'salve',
  'salvo',
  'saman',
  'samba',
  'sambo',
  'samek',
  'samel',
  'samen',
  'sames',
  'samey',
  'samfu',
  'sampi',
  'samps',
  'sands',
  'sandy',
  'saned',
  'saner',
  'sanes',
  'sanga',
  'sangh',
  'sangs',
  'sanko',
  'sansa',
  'santo',
  "sap's",
  'sapan',
  'sapid',
  'sapor',
  'sappy',
  'saran',
  'sards',
  'saree',
  'sarge',
  'sargo',
  'sarin',
  'saris',
  'sarks',
  'sarky',
  'sarod',
  'saros',
  'sarsa',
  'sarus',
  'sasin',
  'sasse',
  'sassy',
  'satay',
  'sated',
  'satem',
  'sates',
  'satin',
  'satis',
  'satyr',
  'sauba',
  'sauce',
  'sauch',
  'saucy',
  'saugh',
  'sauls',
  'sault',
  'sauna',
  'saury',
  'saute',
  'sauts',
  'saved',
  'saver',
  'saves',
  'savey',
  'savin',
  'savor',
  'savoy',
  'savvy',
  "saw's",
  'sawah',
  'sawed',
  'sawer',
  "sax's",
  'saxes',
  "say's",
  'sayed',
  'sayer',
  'sayid',
  'sayon',
  'sayst',
  'scabs',
  'scads',
  'scaff',
  'scags',
  'scail',
  'scala',
  'scald',
  'scale',
  'scall',
  'scalp',
  'scaly',
  'scamp',
  'scams',
  'scans',
  'scant',
  'scapa',
  'scape',
  'scapi',
  'scare',
  'scarf',
  'scarp',
  'scars',
  'scart',
  'scary',
  'scats',
  'scatt',
  'scaud',
  'scaup',
  'scaur',
  'scaws',
  'sceat',
  'scena',
  'scend',
  'scene',
  'scent',
  'schav',
  'schiz',
  'schmo',
  'schul',
  'schwa',
  'scion',
  'sclim',
  'scoff',
  'scogs',
  'scold',
  'scone',
  'scoop',
  'scoot',
  'scopa',
  'scope',
  'scops',
  'score',
  'scorn',
  'scots',
  'scoup',
  'scour',
  'scout',
  'scowl',
  'scows',
  'scrab',
  'scrae',
  'scrag',
  'scram',
  'scran',
  'scrap',
  'scrat',
  'scraw',
  'scray',
  'scree',
  'screw',
  'scrim',
  'scrip',
  'scrod',
  'scrog',
  'scrow',
  'scrub',
  'scrum',
  'scuba',
  'scudi',
  'scudo',
  'scuds',
  'scuff',
  'scuft',
  'scugs',
  'sculk',
  'scull',
  'sculp',
  'sculs',
  'scums',
  'scups',
  'scurf',
  'scurs',
  'scuse',
  'scuta',
  'scute',
  'scuts',
  'scuzz',
  'scyes',
  'sdein',
  "sea's",
  'seals',
  'seams',
  'seamy',
  'seans',
  'sears',
  'seats',
  'sebum',
  "sec's",
  "sec'y",
  'secco',
  'sects',
  'sedan',
  'seder',
  'sedes',
  'sedge',
  'sedgy',
  'sedum',
  "see's",
  'seeds',
  'seedy',
  'seeks',
  'seels',
  'seely',
  'seems',
  'seeps',
  'seepy',
  'seers',
  'segar',
  'segni',
  'segno',
  'segol',
  'segos',
  'segue',
  'seifs',
  'seils',
  'seine',
  'seirs',
  'seise',
  'seism',
  'seity',
  'seize',
  'sekos',
  'selah',
  'selfs',
  'sella',
  'selle',
  'sells',
  'selva',
  'semee',
  'semen',
  'semes',
  'semie',
  'semis',
  "sen's",
  'sends',
  'sengi',
  'senna',
  'senor',
  'sensa',
  'sense',
  'sente',
  'senti',
  'senza',
  'sepad',
  'sepal',
  'sepia',
  'sepic',
  'sepoy',
  'septa',
  'septs',
  'serac',
  'serai',
  'seral',
  'sered',
  'serer',
  'seres',
  'serfs',
  'serge',
  'seric',
  'serif',
  'serin',
  'serks',
  'seron',
  'serow',
  'serra',
  'serre',
  'serrs',
  'serry',
  'serum',
  'serve',
  'servo',
  'sesey',
  'sessa',
  "set's",
  'setae',
  'setal',
  'seton',
  'setts',
  'setup',
  'seven',
  'sever',
  'sewan',
  'sewar',
  'sewed',
  'sewen',
  'sewer',
  'sewin',
  "sex's",
  'sexed',
  'sexer',
  'sexes',
  'sexto',
  'sexts',
  'shack',
  'shade',
  'shads',
  'shady',
  'shaft',
  'shags',
  'shahs',
  'shake',
  'shako',
  'shaky',
  'shale',
  'shall',
  'shalm',
  'shalt',
  'shaly',
  'shama',
  'shame',
  'shams',
  'shank',
  'shans',
  'shape',
  'shaps',
  'shard',
  'share',
  'shark',
  'sharn',
  'sharp',
  'shash',
  'shaul',
  'shave',
  'shawl',
  'shawm',
  'shawn',
  'shaws',
  'shaya',
  'shays',
  'shchi',
  "she'd",
  "she's",
  'sheaf',
  'sheal',
  'shear',
  'sheas',
  'sheds',
  'sheel',
  'sheen',
  'sheep',
  'sheer',
  'sheet',
  'sheik',
  'shelf',
  'shell',
  'shend',
  'shent',
  'sheol',
  'sherd',
  'sheva',
  'shewn',
  'shews',
  'shied',
  'shiel',
  'shier',
  'shies',
  'shift',
  'shill',
  'shily',
  'shims',
  'shine',
  'shins',
  'shiny',
  'ships',
  'shire',
  'shirk',
  'shirr',
  'shirt',
  'shist',
  'shits',
  'shiva',
  'shive',
  'shivs',
  'shlep',
  'shlub',
  'shmek',
  'shoal',
  'shoat',
  'shock',
  'shoed',
  'shoer',
  'shoes',
  'shogi',
  'shogs',
  'shoji',
  'shola',
  'shone',
  'shook',
  'shool',
  'shoon',
  'shoos',
  'shoot',
  'shope',
  'shops',
  'shore',
  'shorl',
  'shorn',
  'short',
  'shote',
  'shots',
  'shott',
  'shout',
  'shove',
  'shown',
  'shows',
  'showy',
  'shoyu',
  'shred',
  'shrew',
  'shris',
  'shrub',
  'shrug',
  'shtik',
  'shtum',
  'shtup',
  'shuck',
  'shuln',
  'shuls',
  'shuns',
  'shunt',
  'shura',
  'shush',
  'shute',
  'shuts',
  'shwas',
  "shy's",
  'shyer',
  'shyly',
  'sials',
  "sib's",
  'sibbs',
  'sibyl',
  'sices',
  'sicko',
  'sicks',
  'sidas',
  'sided',
  'sider',
  'sides',
  'sidha',
  'sidhe',
  'sidle',
  'siege',
  'sieur',
  'sieve',
  'sifts',
  'sighs',
  'sight',
  'sigil',
  'sigla',
  'sigma',
  'signs',
  'sijos',
  'sikas',
  'siker',
  'sikes',
  'silas',
  'silds',
  'siled',
  'silen',
  'siler',
  'siles',
  'silex',
  'silks',
  'silky',
  'sills',
  'silly',
  'silos',
  'silts',
  'silty',
  'silva',
  "sim's",
  'simar',
  'simas',
  'simba',
  'simis',
  'simps',
  'simul',
  "sin's",
  'since',
  'sinds',
  'sines',
  'sinew',
  'singe',
  'sings',
  'sinhs',
  'sinks',
  'sinky',
  'sinus',
  "sip's",
  'siped',
  'sipes',
  "sir's",
  'sired',
  'siree',
  'siren',
  'sires',
  'sirih',
  'siris',
  'siroc',
  'sirra',
  'sirup',
  "sis's",
  'sisal',
  'sisel',
  'sises',
  'sissy',
  'sists',
  'sitar',
  'sited',
  'sites',
  'sithe',
  'situp',
  'situs',
  'siver',
  "six's",
  'sixer',
  'sixes',
  'sixmo',
  'sixte',
  'sixth',
  'sixty',
  'sizar',
  'sized',
  'sizel',
  'sizer',
  'sizes',
  "ska's",
  'skags',
  'skail',
  'skald',
  'skank',
  'skart',
  'skate',
  'skats',
  'skaws',
  'skean',
  'skeed',
  'skeen',
  'skeer',
  'skees',
  'skeet',
  'skegg',
  'skegs',
  'skein',
  'skelf',
  'skell',
  'skelm',
  'skelp',
  'skene',
  'skeos',
  'skeps',
  'skere',
  'skers',
  'skews',
  "ski's",
  'skids',
  'skied',
  'skier',
  'skies',
  'skiey',
  'skiff',
  'skill',
  'skimo',
  'skimp',
  'skims',
  'skink',
  'skins',
  'skint',
  'skips',
  'skirl',
  'skirr',
  'skirt',
  'skite',
  'skits',
  'skive',
  'skivy',
  'skoal',
  'skols',
  'skort',
  'skosh',
  'skran',
  'skrik',
  'skuas',
  'skugs',
  'skulk',
  'skull',
  'skunk',
  "sky's",
  'skyed',
  'skyer',
  'skyey',
  'skyre',
  'slabs',
  'slack',
  'slade',
  'slaes',
  'slags',
  'slain',
  'slake',
  'slams',
  'slane',
  'slang',
  'slank',
  'slant',
  'slaps',
  'slash',
  'slate',
  'slats',
  'slaty',
  'slave',
  'slaws',
  'slays',
  'sleds',
  'sleek',
  'sleep',
  'sleer',
  'sleet',
  'slept',
  'slews',
  'sleys',
  'slice',
  'slick',
  'slide',
  'slier',
  'slily',
  'slime',
  'slims',
  'slimy',
  'sling',
  'slink',
  'slipe',
  'slips',
  'slipt',
  'slish',
  'slits',
  'slive',
  'sloan',
  'slobs',
  'sloes',
  'slogs',
  'sloid',
  'slojd',
  'sloka',
  'sloke',
  'sloom',
  'sloop',
  'sloot',
  'slope',
  'slops',
  'slopy',
  'slosh',
  'sloth',
  'slots',
  'slove',
  'slows',
  'sloyd',
  'slubb',
  'slubs',
  'slued',
  'slues',
  'sluff',
  'slugs',
  'sluit',
  'slump',
  'slums',
  'slung',
  'slunk',
  'slurb',
  'slurp',
  'slurs',
  'sluse',
  'slush',
  'sluts',
  'slyer',
  'slyly',
  'slype',
  'smack',
  'smaik',
  'small',
  'smalm',
  'smalt',
  'smarm',
  'smart',
  'smash',
  'smaze',
  'smear',
  'smeek',
  'smees',
  'smell',
  'smelt',
  'smerk',
  'smews',
  'smile',
  'smily',
  'smirk',
  'smirr',
  'smirs',
  'smite',
  'smith',
  'smits',
  'smock',
  'smogs',
  'smoke',
  'smoko',
  'smoky',
  'smolt',
  'smoot',
  'smore',
  'smote',
  'smous',
  'smout',
  'smowt',
  'smugs',
  'smurf',
  'smurs',
  'smush',
  'smuts',
  'snabs',
  'snack',
  'snafu',
  'snags',
  'snail',
  'snake',
  'snaky',
  'snaps',
  'snare',
  'snarf',
  'snark',
  'snarl',
  'snary',
  'snash',
  'snath',
  'snaws',
  'snead',
  'sneak',
  'sneap',
  'snebs',
  'sneck',
  'sneds',
  'sneed',
  'sneer',
  'snees',
  'snell',
  'snibs',
  'snick',
  'snide',
  'sniff',
  'snift',
  'snigs',
  'snipe',
  'snips',
  'snipy',
  'snirt',
  'snits',
  'snobs',
  'snods',
  'snoek',
  'snogs',
  'snoke',
  'snood',
  'snook',
  'snool',
  'snoop',
  'snoot',
  'snore',
  'snort',
  'snots',
  'snout',
  'snowk',
  'snows',
  'snowy',
  'snubs',
  'snuck',
  'snuff',
  'snugs',
  'snyes',
  'soaks',
  'soaps',
  'soapy',
  'soars',
  'soave',
  "sob's",
  'sobas',
  'sober',
  'socas',
  'socko',
  'socks',
  'socle',
  "sod's",
  'sodas',
  'soddy',
  'sodic',
  'sodom',
  'sofar',
  'sofas',
  'sofer',
  'softa',
  'softs',
  'softy',
  'soger',
  'soggy',
  "soh's",
  'soils',
  'soily',
  'sojas',
  'sokah',
  'soken',
  'sokes',
  'sokol',
  "sol's",
  'solah',
  'solan',
  'solar',
  'solas',
  'soldi',
  'soldo',
  'soled',
  'solei',
  'solen',
  'soler',
  'soles',
  'solfa',
  'solid',
  'solon',
  'solos',
  'solum',
  'solus',
  'solve',
  'soman',
  'somas',
  "son's",
  'sonar',
  'sonce',
  'sonde',
  'sones',
  'songs',
  'sonic',
  'sonly',
  'sonny',
  'sonse',
  'sonsy',
  'sooey',
  'sooks',
  'sools',
  'sooth',
  'soots',
  'sooty',
  "sop's",
  'sophi',
  'sophs',
  'sophy',
  'sopor',
  'soppy',
  'sopra',
  'soral',
  'soras',
  'sorbo',
  'sorbs',
  'sorda',
  'sordo',
  'sords',
  'sored',
  'soree',
  'sorel',
  'sorer',
  'sores',
  'sorex',
  'sorgo',
  'sorns',
  'sorra',
  'sorry',
  'sorta',
  'sorts',
  'sorus',
  "sot's",
  'soths',
  'sotol',
  "sou's",
  'sough',
  'souks',
  'souls',
  'soums',
  'sound',
  'soups',
  'soupy',
  'sourd',
  'sours',
  'souse',
  'south',
  "sow's",
  'sowar',
  'sowed',
  'sower',
  'sowff',
  'sowfs',
  'sowle',
  'sowls',
  'sowse',
  "soy's",
  'soyas',
  'soyuz',
  'sozin',
  "spa's",
  'space',
  'spacy',
  'spade',
  'spado',
  'spaed',
  'spaer',
  'spaes',
  'spahi',
  'spail',
  'spain',
  'spait',
  'spake',
  'spald',
  'spale',
  'spall',
  'spalt',
  'spams',
  'spane',
  'spang',
  'spank',
  'spans',
  'spare',
  'spark',
  'spars',
  'spart',
  'spasm',
  'spate',
  'spats',
  'spawl',
  'spawn',
  'spays',
  'spaza',
  'spazz',
  'speak',
  'speal',
  'spean',
  'spear',
  'speck',
  'specs',
  'speed',
  'speel',
  'speer',
  'speil',
  'speir',
  'speld',
  'spelk',
  'spell',
  'spelt',
  'spend',
  'spent',
  'speos',
  'spere',
  'sperm',
  'spews',
  'spewy',
  'spial',
  'spica',
  'spice',
  'spick',
  'spics',
  'spicy',
  'spied',
  'spiel',
  'spier',
  'spies',
  'spiff',
  'spike',
  'spiky',
  'spile',
  'spill',
  'spilt',
  'spina',
  'spine',
  'spink',
  'spins',
  'spiny',
  'spire',
  'spirt',
  'spiry',
  'spite',
  'spits',
  'spitz',
  'spivs',
  'splat',
  'splay',
  'split',
  'spode',
  'spods',
  'spoil',
  'spoke',
  'spoof',
  'spook',
  'spool',
  'spoom',
  'spoon',
  'spoor',
  'spoot',
  'spore',
  'sport',
  'sposh',
  'spots',
  'spout',
  'sprad',
  'sprag',
  'sprat',
  'spray',
  'spree',
  'sprew',
  'sprig',
  'sprit',
  'sprod',
  'sprog',
  'sprue',
  'sprug',
  'spuds',
  'spued',
  'spues',
  'spume',
  'spumy',
  'spunk',
  'spurn',
  'spurs',
  'spurt',
  'sputa',
  "spy's",
  'squab',
  'squad',
  'squat',
  'squaw',
  'squeg',
  'squib',
  'squid',
  'squit',
  'squiz',
  'sruti',
  'stabs',
  'stacc',
  'stack',
  'stade',
  'staff',
  'stage',
  'stags',
  'stagy',
  'staid',
  'staig',
  'stain',
  'stair',
  'stake',
  'stale',
  'stalk',
  'stall',
  'stamp',
  'stand',
  'stane',
  'stang',
  'stank',
  'staph',
  'staps',
  'stare',
  'stark',
  'starn',
  'starr',
  'stars',
  'start',
  'stash',
  'state',
  'stats',
  'stave',
  'staws',
  'stays',
  'stdio',
  'stead',
  'steak',
  'steal',
  'steam',
  'stean',
  'stear',
  'stedd',
  'stede',
  'steds',
  'steed',
  'steek',
  'steel',
  'steem',
  'steen',
  'steep',
  'steer',
  'steil',
  'stein',
  'stela',
  'stele',
  'stell',
  'stems',
  'stend',
  'steno',
  'stens',
  'stent',
  'steps',
  'stept',
  'stere',
  'stern',
  'stets',
  'stews',
  'stewy',
  'stich',
  'stick',
  'stied',
  'sties',
  'stiff',
  'stilb',
  'stile',
  'still',
  'stilt',
  'stime',
  'stimy',
  'sting',
  'stink',
  'stint',
  'stipa',
  'stipe',
  'stire',
  'stirk',
  'stirp',
  'stirs',
  'stive',
  'stivy',
  'stoae',
  'stoai',
  'stoas',
  'stoat',
  'stobs',
  'stock',
  'stoep',
  'stogy',
  'stoic',
  'stoit',
  'stoke',
  'stola',
  'stole',
  'stoma',
  'stomp',
  'stond',
  'stone',
  'stong',
  'stonk',
  'stony',
  'stood',
  'stook',
  'stool',
  'stoop',
  'stoor',
  'stope',
  'stops',
  'stopt',
  'store',
  'stork',
  'storm',
  'story',
  'stoss',
  'stots',
  'stoun',
  'stoup',
  'stour',
  'stout',
  'stove',
  'stown',
  'stowp',
  'stows',
  'strad',
  'strae',
  'strag',
  'strap',
  'straw',
  'stray',
  'stree',
  'strep',
  'strew',
  'stria',
  'strid',
  'strig',
  'strop',
  'strow',
  'stroy',
  'strum',
  'strut',
  'stubs',
  'stuck',
  'studs',
  'study',
  'stuff',
  'stull',
  'stulm',
  'stumm',
  'stump',
  'stums',
  'stung',
  'stunk',
  'stuns',
  'stunt',
  'stupa',
  'stupe',
  'sturt',
  "sty's",
  'styed',
  'styes',
  'style',
  'styli',
  'stylo',
  'suave',
  "sub's",
  'subah',
  'subas',
  'subby',
  'suber',
  'succi',
  'sucks',
  'sucre',
  'sudds',
  'sudor',
  'sudsy',
  'suede',
  'suers',
  'suets',
  'suety',
  'sugar',
  'sughs',
  'suing',
  'suint',
  'suite',
  'suits',
  'sujee',
  'sukhs',
  'sulci',
  'sulfa',
  'sulfo',
  'sulks',
  'sulky',
  'sully',
  'sulus',
  "sum's",
  'sumac',
  'summa',
  'sumos',
  'sumph',
  'sumps',
  "sun's",
  'sunis',
  'sunks',
  'sunna',
  'sunns',
  'sunny',
  'sunup',
  "sup's",
  'super',
  'supes',
  'suppl',
  'supra',
  'surah',
  'sural',
  'suras',
  'surat',
  'surds',
  'surer',
  'sures',
  'surfs',
  'surfy',
  'surge',
  'surgy',
  'surly',
  'surra',
  'sushi',
  'susus',
  'sutor',
  'sutra',
  'sutta',
  'swabs',
  'swack',
  'swads',
  'swage',
  'swags',
  'swail',
  'swain',
  'swale',
  'swaly',
  'swami',
  'swamp',
  'swamy',
  'swang',
  'swank',
  'swans',
  'swaps',
  'sward',
  'sware',
  'swarf',
  'swarm',
  'swart',
  'swash',
  'swath',
  'swats',
  'sways',
  'sweal',
  'swear',
  'sweat',
  'swede',
  'sweep',
  'sweer',
  'sweet',
  'sweir',
  'swell',
  'swelt',
  'swept',
  'swies',
  'swift',
  'swigs',
  'swill',
  'swims',
  'swine',
  'swing',
  'swink',
  'swipe',
  'swire',
  'swirl',
  'swish',
  'swiss',
  'swith',
  'swive',
  'swizz',
  'swonk',
  'swoon',
  'swoop',
  'swops',
  'sword',
  'swore',
  'sworn',
  'swots',
  'swoun',
  'swung',
  'sybil',
  'syboe',
  'sybow',
  'sycee',
  'syces',
  'syker',
  'sykes',
  'sylis',
  'sylph',
  'sylva',
  'symar',
  'synch',
  'syncs',
  'synds',
  'syned',
  'synes',
  'synod',
  'synop',
  'synth',
  'syped',
  'sypes',
  'syphs',
  'syrah',
  'syren',
  'syrup',
  'sysop',
  'syver',
  "ta'en",
  "tab's",
  'tabby',
  'taber',
  'tabes',
  'tabid',
  'tabis',
  'tabla',
  'table',
  'taboo',
  'tabor',
  'tabun',
  'tabus',
  'taces',
  'tacet',
  'tache',
  'tacho',
  'tachs',
  'tacit',
  'tacks',
  'tacky',
  'tacos',
  'tacts',
  "tad's",
  'taegu',
  'taels',
  'taffy',
  'tafia',
  "tag's",
  'taggy',
  'tagma',
  'tahas',
  'tahrs',
  'taiga',
  'taigs',
  'tails',
  'tains',
  'taint',
  'taira',
  'taish',
  'taits',
  'tajes',
  'takas',
  'taken',
  'taker',
  'takes',
  'takhi',
  'takin',
  'takis',
  'talak',
  'talaq',
  'talar',
  'talas',
  'talcs',
  'talcy',
  'talea',
  'taler',
  'tales',
  'talks',
  'talky',
  'talls',
  'tally',
  'talma',
  'talon',
  'talpa',
  'taluk',
  'talus',
  "tam's",
  'tamal',
  'tamed',
  'tamer',
  'tames',
  'tamin',
  'tamis',
  'tammy',
  'tamps',
  "tan's",
  'tanas',
  'tanga',
  'tangi',
  'tango',
  'tangs',
  'tangy',
  'tanka',
  'tanks',
  'tanky',
  'tanna',
  'tansy',
  'tanti',
  'tanto',
  "tap's",
  'tapas',
  'taped',
  'tapen',
  'taper',
  'tapes',
  'tapet',
  'tapir',
  'tapis',
  'tappa',
  'tapus',
  "tar's",
  'taras',
  'tardo',
  'tardy',
  'tared',
  'tares',
  'targe',
  'tarns',
  'taroc',
  'tarok',
  'taros',
  'tarot',
  'tarps',
  'tarre',
  'tarry',
  'tarsi',
  'tarts',
  'tarty',
  'tasar',
  'taser',
  'tasks',
  'tasse',
  'taste',
  'tasty',
  "tat's",
  'tatar',
  'tater',
  'tates',
  'taths',
  'tatie',
  'tatin',
  'tatou',
  'tatts',
  'tatty',
  'tatus',
  "tau's",
  'taube',
  'taunt',
  'tauon',
  'taupe',
  'tauts',
  'tavah',
  'tavas',
  'taver',
  "taw's",
  'tawas',
  'tawed',
  'tawer',
  'tawie',
  'tawny',
  'tawse',
  "tax's",
  'taxed',
  'taxer',
  'taxes',
  'taxis',
  'taxol',
  'taxon',
  'taxor',
  'taxus',
  'tayra',
  'tazza',
  'tazze',
  "tea's",
  'teach',
  'teade',
  'teaed',
  'teaer',
  'teaks',
  'teals',
  'teams',
  'tears',
  'teary',
  'tease',
  'teats',
  'teaze',
  'techs',
  'techy',
  'tecta',
  'teddy',
  "tee's",
  'teels',
  'teems',
  'teens',
  'teeny',
  'teers',
  'teeth',
  'teffs',
  "teg's",
  'teggs',
  'tegua',
  'tegus',
  'tehee',
  'tehrs',
  'teiid',
  'teils',
  'teind',
  'telae',
  'telco',
  'teleg',
  'teles',
  'telex',
  'telia',
  'telic',
  'tells',
  'telly',
  'teloi',
  'telos',
  'temes',
  'tempe',
  'tempi',
  'tempo',
  'temps',
  'tempt',
  'temse',
  "ten's",
  'tench',
  'tends',
  'tendu',
  'tenes',
  'tenet',
  'tenga',
  'tenge',
  'tenia',
  'tenne',
  'tenno',
  'tenny',
  'tenon',
  'tenor',
  'tense',
  'tenth',
  'tents',
  'tenty',
  'tenue',
  'tepal',
  'tepas',
  'tepee',
  'tepid',
  'tepoy',
  'terai',
  'teras',
  'terce',
  'terek',
  'teres',
  'terga',
  'terma',
  'terms',
  'terne',
  'terns',
  'terra',
  'terre',
  'terrs',
  'terry',
  'terse',
  'terts',
  'tesla',
  'testa',
  'teste',
  'tests',
  'testy',
  'teths',
  'tetra',
  'tetri',
  'teuch',
  'teugh',
  'tewed',
  'tewel',
  'tewit',
  'texas',
  'texts',
  'thack',
  'thagi',
  'thana',
  'thane',
  'thank',
  'tharm',
  'thars',
  'thaws',
  'thawy',
  'thebe',
  'theca',
  'theed',
  'theek',
  'thees',
  'theft',
  'thegn',
  'theic',
  'thein',
  'their',
  'thema',
  'theme',
  'thens',
  'theol',
  'theow',
  'there',
  'therm',
  'theta',
  'thete',
  'thews',
  'thewy',
  'thick',
  'thief',
  'thigh',
  'thigs',
  'thilk',
  'thill',
  'thine',
  'thing',
  'think',
  'thins',
  'thiol',
  'third',
  'thirl',
  'thoft',
  'thole',
  'tholi',
  'thong',
  'thorn',
  'thoro',
  'thorp',
  'those',
  'thous',
  'thowl',
  'thraw',
  'three',
  'threw',
  'thrip',
  'throb',
  'throe',
  'throw',
  'thrum',
  'thuds',
  'thugs',
  'thuja',
  'thumb',
  'thump',
  'thunk',
  'thurl',
  'thuya',
  "thy's",
  'thyme',
  'thymi',
  'thymy',
  'tiara',
  'tiars',
  'tibia',
  "tic's",
  'tical',
  'ticca',
  'tices',
  'tichy',
  'ticks',
  'ticky',
  'tidal',
  'tiddy',
  'tided',
  'tides',
  "tie's",
  'tiers',
  'tiffs',
  'tifts',
  'tiger',
  'tiges',
  'tight',
  'tigon',
  'tikas',
  'tikes',
  'tikis',
  'tikka',
  'tilak',
  'tilde',
  'tiled',
  'tiler',
  'tiles',
  'tills',
  'tilth',
  'tilts',
  'timbo',
  'timed',
  'timer',
  'times',
  'timid',
  'timon',
  'timps',
  "tin's",
  'tinct',
  'tinds',
  'tinea',
  'tined',
  'tines',
  'tinge',
  'tings',
  'tinks',
  'tinny',
  'tints',
  'tinty',
  "tip's",
  'tipis',
  'tippy',
  'tipsy',
  'tipup',
  'tired',
  'tires',
  'tirls',
  'tiros',
  'tirrs',
  "tit's",
  'titan',
  'titch',
  'titer',
  'tithe',
  'titis',
  'title',
  'titre',
  'titty',
  'titup',
  'tiyin',
  'tizzy',
  'toads',
  'toady',
  'toast',
  'toaze',
  'tocks',
  'tocos',
  'today',
  'toddy',
  "toe's",
  'toeas',
  'toffs',
  'toffy',
  'tofts',
  'tofus',
  "tog's",
  'togae',
  'togas',
  'togue',
  'tohos',
  'toile',
  'toils',
  'toise',
  'toits',
  'tokay',
  'toked',
  'token',
  'toker',
  'tokes',
  'tokos',
  'tolan',
  'tolar',
  'tolas',
  'toled',
  'toles',
  'tolls',
  'tolly',
  'tolts',
  'tolus',
  'tolyl',
  "tom's",
  'toman',
  'tombs',
  'tomes',
  'tommy',
  "ton's",
  'tonal',
  'tondi',
  'tondo',
  'toned',
  'toner',
  'tones',
  'toney',
  'tonga',
  'tongs',
  'tonic',
  'tonks',
  'tonne',
  'tonto',
  'tonus',
  'tools',
  'tooms',
  'toons',
  'tooth',
  'toots',
  "top's",
  'topaz',
  'toped',
  'topee',
  'topek',
  'toper',
  'topes',
  'tophe',
  'tophi',
  'tophs',
  'topic',
  'topis',
  'topog',
  'topoi',
  'topos',
  'toque',
  "tor's",
  'torah',
  'toran',
  'toras',
  'torch',
  'torcs',
  'tores',
  'toric',
  'torii',
  'toros',
  'torot',
  'torrs',
  'torse',
  'torsi',
  'torsk',
  'torso',
  'torte',
  'torts',
  'torus',
  'tosas',
  'tosed',
  'toses',
  'toshy',
  'tossy',
  "tot's",
  'total',
  'toted',
  'totem',
  'toter',
  'totes',
  'totty',
  'touch',
  'tough',
  'touns',
  'tours',
  'touse',
  'tousy',
  'touts',
  "tow's",
  'towed',
  'towel',
  'tower',
  'towie',
  'towns',
  'towny',
  'toxic',
  'toxin',
  "toy's",
  'toyed',
  'toyer',
  'toyon',
  'toyos',
  'tozed',
  'tozes',
  'trace',
  'track',
  'tract',
  'trade',
  'tragi',
  'traik',
  'trail',
  'train',
  'trait',
  'tramp',
  'trams',
  'trank',
  'tranq',
  'trans',
  'trant',
  'trape',
  'traps',
  'trapt',
  'trash',
  'trass',
  'trats',
  'tratt',
  'trave',
  'trawl',
  'trays',
  'tread',
  'treas',
  'treat',
  'treck',
  'treed',
  'treen',
  'trees',
  'trefa',
  'treif',
  'treks',
  'trema',
  'trend',
  'tress',
  'trets',
  'trews',
  'treys',
  'triac',
  'triad',
  'trial',
  'tribe',
  'trice',
  'trick',
  'tried',
  'trier',
  'tries',
  'triff',
  'trigo',
  'trigs',
  'trike',
  'trill',
  'trims',
  'trine',
  'trins',
  'triol',
  'trior',
  'trios',
  'tripe',
  'trips',
  'tripy',
  'trist',
  'trite',
  'troad',
  'troak',
  'troat',
  'trock',
  'trode',
  'trogs',
  'trois',
  'troke',
  'troll',
  'tromp',
  'trona',
  'tronc',
  'trone',
  'trons',
  'troop',
  'trooz',
  'trope',
  'troth',
  'trots',
  'trout',
  'trove',
  'trows',
  'troys',
  'truce',
  'truck',
  'trued',
  'truer',
  'trues',
  'trugs',
  'trull',
  'truly',
  'trump',
  'trunk',
  'truss',
  'trust',
  'truth',
  "try's",
  'tryer',
  'tryma',
  'tryst',
  'tsade',
  'tsadi',
  'tsars',
  'tsked',
  'tsuba',
  'tuans',
  'tuart',
  'tuath',
  "tub's",
  'tubae',
  'tubal',
  'tubar',
  'tubas',
  'tubby',
  'tubed',
  'tuber',
  'tubes',
  'tucks',
  'tufas',
  'tuffs',
  'tufts',
  'tufty',
  "tug's",
  'tugra',
  'tuism',
  'tules',
  'tulip',
  'tulle',
  "tum's",
  'tumid',
  'tummy',
  'tumor',
  'tumps',
  "tun's",
  'tunas',
  'tunds',
  'tuned',
  'tuner',
  'tunes',
  'tungs',
  'tunic',
  'tunny',
  "tup's",
  'tupek',
  'tupik',
  'tuple',
  'tuque',
  'turbo',
  'turds',
  'turfs',
  'turfy',
  'turks',
  'turms',
  'turns',
  'turps',
  'tushy',
  'tusks',
  'tusky',
  "tut's",
  'tutee',
  'tutor',
  'tutti',
  'tutty',
  'tutus',
  "tux's",
  'tuxes',
  'tuyer',
  'twaes',
  'twain',
  'twals',
  'twang',
  'twank',
  'twats',
  'tways',
  'tweak',
  'tweed',
  'tweel',
  'tween',
  'tweer',
  'tweet',
  'twerk',
  'twerp',
  'twice',
  'twier',
  'twigs',
  'twill',
  'twilt',
  'twine',
  'twink',
  'twins',
  'twiny',
  'twire',
  'twirl',
  'twirp',
  'twist',
  'twite',
  'twits',
  'twixt',
  "two's",
  'twoer',
  'twyer',
  'tyees',
  'tyers',
  'tying',
  'tyiyn',
  'tykes',
  'tyler',
  'tymps',
  'tyned',
  'tynes',
  'typal',
  'typed',
  'types',
  'typey',
  'typic',
  'typos',
  'typps',
  'typto',
  'tyres',
  'tyros',
  'tythe',
  'tzars',
  'udals',
  'udder',
  'udons',
  'ugged',
  "ugh's",
  'uglis',
  'uhlan',
  'uhuru',
  'ukase',
  "uke's",
  'ulama',
  'ulans',
  'ulcer',
  'ulema',
  'ulmin',
  'ulnad',
  'ulnae',
  'ulnar',
  'ulnas',
  'ulpan',
  'ultra',
  'ulvas',
  'umbel',
  'umber',
  'umbos',
  'umbra',
  'umbre',
  'umiac',
  'umiak',
  'umiaq',
  'ummah',
  'ummas',
  "ump's",
  'umped',
  'umphs',
  'umpty',
  'unais',
  'unapt',
  'unarm',
  'unary',
  'unaus',
  'unbag',
  'unban',
  'unbar',
  'unbed',
  'unbid',
  'unbox',
  'uncap',
  'unces',
  'uncia',
  'uncle',
  'uncos',
  'uncoy',
  'uncus',
  'uncut',
  'undam',
  'undee',
  'under',
  'undid',
  'undue',
  'undug',
  'unfed',
  'unfit',
  'unfix',
  'ungag',
  'unget',
  'ungod',
  'ungot',
  'ungum',
  'unhat',
  'unhip',
  'unify',
  'union',
  'unite',
  'units',
  'unity',
  'unjam',
  'unked',
  'unket',
  'unkid',
  'unlaw',
  'unlay',
  'unled',
  'unlet',
  'unlid',
  'unlit',
  'unman',
  'unmet',
  'unmew',
  'unmix',
  'unpay',
  'unpeg',
  'unpen',
  'unpin',
  'unred',
  'unrid',
  'unrig',
  'unrip',
  'unsay',
  'unset',
  'unsew',
  'unsex',
  'unsod',
  'untax',
  'untie',
  'until',
  'untin',
  'unwed',
  'unwet',
  'unwit',
  'unwon',
  'unzip',
  'upbow',
  'upbye',
  'updos',
  'updry',
  'upend',
  'upjet',
  'uplay',
  'upled',
  'uplit',
  'upped',
  'upper',
  'upran',
  'uprun',
  'upsee',
  'upset',
  'upsey',
  'uptie',
  'uraei',
  'urali',
  'urare',
  'urari',
  'urase',
  'urate',
  'urban',
  'urbia',
  'urdee',
  'ureal',
  'ureas',
  'uredo',
  'ureic',
  'urena',
  'urent',
  'urged',
  'urger',
  'urges',
  'urial',
  'urine',
  'urite',
  'urman',
  "urn's",
  'urnal',
  'urned',
  'urped',
  'ursae',
  'ursid',
  'urson',
  'urubu',
  'urvas',
  'usage',
  "use's",
  'users',
  'usher',
  'usnea',
  'usque',
  'usual',
  'usure',
  'usurp',
  'usury',
  'uteri',
  'utile',
  'utter',
  'uveal',
  'uveas',
  'uvula',
  "vac's",
  'vacua',
  'vadas',
  'vagal',
  'vague',
  'vagus',
  'vails',
  'vaire',
  'vairs',
  'vairy',
  'vakil',
  'vales',
  'valet',
  'valid',
  'valis',
  'valla',
  'valor',
  'valse',
  'value',
  'valve',
  'vamps',
  'vampy',
  "van's",
  'vanda',
  'vaned',
  'vanes',
  'vangs',
  'vaped',
  'vapes',
  'vapid',
  'vapor',
  "var's",
  'varan',
  'varas',
  'vardy',
  'varec',
  'vares',
  'varia',
  'varix',
  'varna',
  'varus',
  'varve',
  "vas's",
  'vasal',
  'vases',
  'vasts',
  'vasty',
  "vat's",
  'vatic',
  'vatus',
  'vault',
  'vaunt',
  'veals',
  'vealy',
  'vedic',
  'veena',
  'veeps',
  'veers',
  'veery',
  "veg's",
  'vegan',
  'vegas',
  'veges',
  'vegie',
  'veils',
  'veily',
  'veins',
  'veiny',
  'velar',
  'velds',
  'veldt',
  'vells',
  'velum',
  'venae',
  'venal',
  'vends',
  'veney',
  'venge',
  'venin',
  'venom',
  'vents',
  'venue',
  'venus',
  'verbs',
  'verey',
  'verge',
  'verry',
  'versa',
  'verse',
  'verso',
  'verst',
  'verts',
  'vertu',
  'verve',
  'vespa',
  'vesta',
  'vests',
  "vet's",
  'vetch',
  'veter',
  'vexed',
  'vexer',
  'vexes',
  'vexil',
  'vezir',
  "via's",
  'vials',
  'viand',
  'vibes',
  'vibex',
  'vicar',
  'viced',
  'vices',
  'vichy',
  'video',
  'viers',
  'views',
  'viewy',
  'vifda',
  'vigas',
  'vigia',
  'vigil',
  'vigor',
  'viler',
  'villa',
  'villi',
  'vills',
  "vim's",
  'vimen',
  'vinal',
  'vinas',
  'vinca',
  'vined',
  'viner',
  'vines',
  'vinew',
  'vinic',
  'vinos',
  'vints',
  'vinyl',
  'viola',
  'viols',
  'viper',
  'viral',
  'vired',
  'vireo',
  'vires',
  'virga',
  'virge',
  'virid',
  'virls',
  'virtu',
  'virus',
  'visas',
  'vised',
  'vises',
  'visie',
  'visit',
  'visna',
  'visne',
  'vison',
  'visor',
  'vista',
  'visto',
  'vitae',
  'vital',
  'vitas',
  'vitex',
  'vitta',
  'vivas',
  'vivat',
  'vivax',
  'vivda',
  'viver',
  'vives',
  'vivid',
  'vivre',
  'vixen',
  'vizir',
  'vizor',
  'vleis',
  'vlies',
  'voars',
  'vocab',
  'vocal',
  'voces',
  'vodka',
  'vodou',
  'vodun',
  'vogie',
  'vogue',
  'voice',
  'voids',
  'voila',
  'voile',
  'volae',
  'volar',
  'volas',
  'voled',
  'voles',
  'volet',
  'volks',
  'volta',
  'volte',
  'volti',
  'volts',
  'volva',
  'vomer',
  'vomit',
  'voops',
  'voted',
  'voter',
  'votes',
  'vouch',
  'vouge',
  'voulu',
  "vow's",
  'vowed',
  'vowel',
  'vower',
  'vozhd',
  'vraic',
  'vroom',
  'vrouw',
  'vrows',
  'vuggs',
  'vuggy',
  'vughs',
  'vulgo',
  'vulns',
  'vulva',
  'vying',
  'wacke',
  'wacko',
  'wacks',
  'wacky',
  "wad's",
  'wadas',
  'waddy',
  'waded',
  'wader',
  'wades',
  'wadge',
  'wadis',
  'wafer',
  'waffs',
  'wafts',
  "wag's",
  'waged',
  'wager',
  'wages',
  'wagon',
  'wahoo',
  'waifs',
  'wails',
  'wains',
  'wairs',
  'waist',
  'waits',
  'waive',
  'wakas',
  'waked',
  'waken',
  'waker',
  'wakes',
  'wakil',
  'waldo',
  'waled',
  'waler',
  'wales',
  'walis',
  'walks',
  'walls',
  'wally',
  'walty',
  'waltz',
  'wamed',
  'wames',
  'wamus',
  'wands',
  'waned',
  'wanes',
  'waney',
  'wanks',
  'wanle',
  'wanly',
  'wanna',
  'wants',
  'wanty',
  'wanze',
  "war's",
  'warby',
  'wards',
  'wared',
  'wares',
  'warez',
  'warks',
  'warms',
  'warns',
  'warps',
  'warst',
  'warts',
  'warty',
  'wases',
  'washy',
  'wasms',
  'wasps',
  'waspy',
  'waste',
  'wasts',
  'watap',
  'watch',
  'water',
  'watts',
  'waugh',
  'wauks',
  'waulk',
  'wauls',
  'waved',
  'waver',
  'waves',
  'wavey',
  "waw's",
  'wawas',
  'wawls',
  "wax's",
  'waxed',
  'waxen',
  'waxer',
  'waxes',
  "way's",
  'wazir',
  'wazoo',
  "we'll",
  "we're",
  "we've",
  'weald',
  'weals',
  'weans',
  'wears',
  'weary',
  'weave',
  "web's",
  'webby',
  'weber',
  'wecht',
  'wecks',
  'wedel',
  'wedge',
  'wedgy',
  "wee's",
  'weeds',
  'weedy',
  'weeks',
  'weels',
  'weems',
  'weens',
  'weeny',
  'weeps',
  'weepy',
  'weest',
  'weets',
  'wefte',
  'wefts',
  'weigh',
  'weils',
  'weird',
  'weirs',
  'wekas',
  'welch',
  'welds',
  'welks',
  'wells',
  'welly',
  'welsh',
  'welts',
  "wen's",
  'wench',
  'wends',
  'wenge',
  'wenny',
  'wersh',
  'wests',
  "wet's",
  'wetas',
  'wetly',
  'whack',
  'whale',
  'whamo',
  'whams',
  'whang',
  'whaps',
  'whare',
  'wharf',
  'whats',
  'whaup',
  'whaur',
  'wheal',
  'wheat',
  'wheel',
  'wheen',
  'wheep',
  'whees',
  'wheft',
  'whelk',
  'whelm',
  'whelp',
  'whens',
  'where',
  'whets',
  'whews',
  'wheys',
  'which',
  'whids',
  'whiff',
  'whift',
  'whigs',
  'while',
  'whilk',
  'whims',
  'whine',
  'whins',
  'whiny',
  'whips',
  'whipt',
  'whirl',
  'whirr',
  'whirs',
  'whish',
  'whisk',
  'whiss',
  'whist',
  'white',
  'whits',
  'whity',
  'whizz',
  "who'd",
  "who's",
  'whoas',
  'whole',
  'whomp',
  'whoof',
  'whoop',
  'whops',
  'whore',
  'whorl',
  'whort',
  'whose',
  'whoso',
  'whsle',
  'whump',
  'whups',
  "why'd",
  "why's",
  'wicca',
  'wicks',
  'wicky',
  'widdy',
  'widen',
  'wider',
  'wides',
  'widow',
  'width',
  'wield',
  'wifed',
  'wifes',
  'wifie',
  'wifty',
  "wig's",
  'wigan',
  'wiggy',
  'wight',
  'wikis',
  'wilco',
  'wilds',
  'wiled',
  'wiles',
  'wilga',
  'wilis',
  'wilja',
  'wills',
  'willy',
  'wilts',
  'wimps',
  'wimpy',
  "win's",
  "win't",
  'wince',
  'winch',
  'winds',
  'windy',
  'wined',
  'wines',
  'winey',
  'wings',
  'wingy',
  'winks',
  'winna',
  'winns',
  'winos',
  'winze',
  'wiped',
  'wiper',
  'wipes',
  'wired',
  'wirer',
  'wires',
  'wirra',
  'wised',
  'wisen',
  'wiser',
  'wises',
  'wisha',
  'wisps',
  'wispy',
  'wists',
  "wit's",
  'witan',
  'witch',
  'wited',
  'wites',
  'withe',
  'withs',
  'withy',
  'witty',
  'wived',
  'wiver',
  'wives',
  "wiz's",
  'wizen',
  'wizes',
  'woads',
  'woald',
  'wocks',
  'wodge',
  "woe's",
  'woful',
  "wok's",
  'woken',
  'wolds',
  'wolfs',
  'wolly',
  'wolve',
  'woman',
  'wombs',
  'womby',
  'women',
  'womyn',
  "won's",
  "won't",
  'wonga',
  'wongi',
  'wonks',
  'wonky',
  'wonts',
  'woods',
  'woody',
  'wooed',
  'wooer',
  'woofs',
  'woofy',
  'woold',
  'wools',
  'wooly',
  'woops',
  'woosh',
  'wootz',
  'woozy',
  "wop's",
  'words',
  'wordy',
  'works',
  'world',
  'worms',
  'wormy',
  'worry',
  'worse',
  'worst',
  'worth',
  'worts',
  'wound',
  'woven',
  "wow's",
  'wowed',
  'wowee',
  "wpm's",
  'wrack',
  'wrang',
  'wraps',
  'wrapt',
  'wrath',
  'wrawl',
  'wreak',
  'wreck',
  'wrens',
  'wrest',
  'wrick',
  'wried',
  'wrier',
  'wries',
  'wring',
  'wrist',
  'write',
  'writs',
  'wroke',
  'wrong',
  'wroot',
  'wrote',
  'wroth',
  'wrung',
  'wryer',
  'wryly',
  'wulls',
  'wurst',
  'wushu',
  'wussy',
  'wyled',
  'wyles',
  'wynds',
  'wynns',
  'wyted',
  'wytes',
  'xcvii',
  'xebec',
  'xenia',
  'xenic',
  'xenon',
  'xeric',
  'xerox',
  'xerus',
  'xoana',
  'xrefs',
  'xterm',
  'xviii',
  'xxiii',
  'xxvii',
  'xxxii',
  'xxxiv',
  'xxxix',
  'xxxvi',
  'xylan',
  'xylem',
  'xylic',
  'xylol',
  'xylyl',
  'xysti',
  'xysts',
  "y'all",
  'yabby',
  'yaboo',
  'yacca',
  'yacht',
  'yacks',
  'yaffs',
  'yager',
  'yagis',
  'yahoo',
  'yaird',
  "yak's",
  'yakka',
  'yakow',
  'yales',
  "yam's",
  'yamen',
  'yamun',
  'yangs',
  'yanks',
  "yap's",
  'yapok',
  'yapon',
  'yapps',
  'yappy',
  'yards',
  'yarer',
  'yarns',
  'yarrs',
  'yatra',
  'yauds',
  'yauld',
  'yaups',
  "yaw's",
  'yawed',
  'yawey',
  'yawls',
  'yawns',
  'yawny',
  'yawps',
  'yclad',
  'ydrad',
  'ydred',
  "yea's",
  'yeahs',
  'yealm',
  'yeans',
  'yeard',
  'yearn',
  'years',
  'yeast',
  'yecch',
  'yechs',
  'yechy',
  'yeggs',
  'yelks',
  'yells',
  'yelms',
  'yelps',
  'yelts',
  "yen's",
  'yenta',
  'yente',
  "yep's",
  'yerba',
  'yerds',
  'yerks',
  "yes's",
  'yeses',
  'yesty',
  'yetis',
  'yetts',
  'yeuks',
  'yeuky',
  'yeven',
  "yew's",
  'yexed',
  'yexes',
  'yfere',
  'yield',
  'yikes',
  'yills',
  "yin's",
  'yince',
  "yip's",
  'yipee',
  'yipes',
  'yippy',
  'yirds',
  'yirks',
  'yirrs',
  'yirth',
  'yites',
  'ylems',
  'ylkes',
  "yob's",
  'yobbo',
  'yocks',
  'yodel',
  'yodhs',
  'yodle',
  'yogas',
  'yogee',
  'yoghs',
  'yogic',
  'yogin',
  'yogis',
  'yoick',
  'yojan',
  'yoked',
  'yokel',
  'yokes',
  'yolks',
  'yolky',
  'yomim',
  'yomps',
  'yonic',
  'yonis',
  'yonks',
  'yoops',
  'yores',
  'yorks',
  "you'd",
  "you's",
  'youks',
  'young',
  'yourn',
  'yours',
  'yourt',
  'youse',
  'youth',
  'yowed',
  'yowes',
  'yowie',
  'yowls',
  'yrapt',
  'yrent',
  'yrivd',
  'yrneh',
  'yuans',
  'yucas',
  'yucca',
  'yucch',
  'yuchy',
  'yucks',
  'yucky',
  'yugas',
  "yuk's",
  'yuked',
  'yukes',
  'yukky',
  'yukos',
  'yulan',
  'yules',
  'yummy',
  'yumps',
  "yup's",
  'yupon',
  'yuppy',
  'yurta',
  'yurts',
  'zabra',
  'zacks',
  "zag's",
  'zaire',
  'zakat',
  'zaman',
  'zambo',
  'zamia',
  'zanja',
  'zante',
  'zanza',
  'zanze',
  "zap's",
  'zappy',
  'zarfs',
  'zaris',
  'zatis',
  'zaxes',
  'zayin',
  'zazen',
  'zeals',
  'zebec',
  'zebra',
  'zebub',
  'zebus',
  "zed's",
  "zee's",
  'zeins',
  'zeist',
  'zendo',
  "zep's",
  'zerda',
  'zerks',
  'zeros',
  'zests',
  'zesty',
  'zetas',
  'zezes',
  'zhomo',
  'zibet',
  'ziffs',
  "zig's",
  'zigan',
  'zilas',
  'zilch',
  'zilla',
  'zills',
  'zimbi',
  'zimbs',
  'zinco',
  'zincs',
  'zincy',
  'zineb',
  'zines',
  'zings',
  'zingy',
  'zinke',
  'zinky',
  "zip's",
  'zippo',
  'zippy',
  'ziram',
  "zit's",
  'zitis',
  'zitty',
  'zizel',
  'zizit',
  'zlote',
  'zloty',
  'zoaea',
  'zobos',
  'zobus',
  'zocco',
  'zoeae',
  'zoeal',
  'zoeas',
  'zoism',
  'zoist',
  'zombi',
  'zonae',
  'zonal',
  'zonda',
  'zoned',
  'zoner',
  'zones',
  'zonks',
  "zoo's",
  'zooea',
  'zooey',
  'zooid',
  'zooks',
  'zooms',
  'zoons',
  'zooty',
  'zoppa',
  'zoppo',
  'zorch',
  'zoril',
  'zoris',
  'zorro',
  'zouks',
  'zowie',
  'zupan',
  'zupas',
  'zurfs',
  'zuzes',
  'zygal',
  'zygon',
  'zymes',
  'zymic',
  "y'are",
  'pluto',
  'afric',
  'seest',
  'galen',
  'tiber',
  'italy',
  'diest',
  "ey'st",
  'priam',
  'damon',
  'petar',
  'liest',
  'esill',
  'osric',
  'percy',
  'athol',
  'hybla',
  'irish',
  'poins',
  'ebrew',
  'glend',
  'trent',
  'india',
  'useth',
  'berod',
  'exion',
  'gower',
  'hiren',
  'simon',
  'chopt',
  'dalea',
  'helen',
  'imbar',
  'crete',
  'pauca',
  'berri',
  'wouid',
  'feith',
  'grund',
  'breff',
  'jewry',
  'alice',
  'pense',
  'gagne',
  'aussi',
  'doute',
  'ilbow',
  'votre',
  'autre',
  'assez',
  'prave',
  'pless',
  'chien',
  'truie',
  'calen',
  'cette',
  'entre',
  'gipes',
  'plood',
  'jeshu',
  'pread',
  'sould',
  'quand',
  'divin',
  "d'une",
  "n'est",
  'latin',
  "go'st",
  'anjou',
  'sueth',
  'patay',
  'maine',
  'alton',
  'sicil',
  'alban',
  'nevil',
  'sylla',
  'timor',
  'goffe',
  'essex',
  'sinon',
  'shipt',
  'aesop',
  'pepin',
  "ev'ry",
  'bohun',
  'egypt',
  'asher',
  'denny',
  "w'are",
  'april',
  'milan',
  'melun',
  'casca',
  'cinna',
  'pella',
  'varro',
  'labio',
  'wheer',
  'regan',
  'edgar',
  'owest',
  'goest',
  'curan',
  "ow'st",
  'bemet',
  "ye'll",
  'boyet',
  "t'one",
  'caelo',
  'sapit',
  'deckt',
  'ilion',
  'sweno',
  "we'ld",
  'lucio',
  'jacob',
  'diana',
  'crost',
  'padua',
  'medea',
  'aeson',
  'prain',
  'evans',
  'verba',
  'prief',
  'tevil',
  'caius',
  'chaud',
  'mette',
  "qu'ai",
  'varld',
  'herod',
  'pible',
  'horum',
  'herne',
  'pinse',
  'satan',
  'corin',
  'lulla',
  'claud',
  'balth',
  "be'st",
  'lieth',
  'bagot',
  'yicld',
  'glose',
  'exton',
  'lovel',
  'livia',
  'susan',
  'fadom',
  'cursy',
  'usest',
  'goeth',
  'apoth',
  "al'ce",
  'tutto',
  'licio',
  'regia',
  'swoln',
  'dowle',
  'titus',
  'aaron',
  'hullo',
  'styga',
  'aetna',
  'weeke',
  'scath',
  'sperr',
  'sleid',
  'arion',
  'facit',
  'topas',
  'passy',
  'julia',
  'lozel',
  'barne',
  'mopsa',
  'farre',
  'libya',
  'julio',
  'lafeu',
  'isbel',
  'corbo',
  'bosko',
  'cosmo',
  'philo',
  'syria',
  'ionia',
  'pansa',
  'menas',
  'eliad',
  'sheed',
  'wheak',
  'seese',
  'feste',
  'swown',
  "'orld",
  'sfoot',
  'tereu',
  "'lack",
  'cleon',
  'swort',
  'lafew',
  'panyn',
  'frush',
  'creon',
  'phang',
  'jason',
  "'oman",
  'niobe',
  'cleap',
  'rosse',
  'aliad',
  'onixe',
  'sicle',
  'husht',
  'blowt',
  'sarah',
  'graff',
  'hagar',
  'pring',
  'histy',
  'magni',
  'peard',
  'senoy',
  'tanta',
  'egeon',
  'enurn',
  'tully',
  "'fore",
  'beest',
  'celia',
  'parca',
  'ardea',
  "'tish",
  'sarum',
  'circe',
  'bolin',
  'laban',
  'virgo',
  'sinow',
  'wanny',
  "'udge"
];